export const common = {
emptyValue: "—",
a11y: {
goBack: "Retour",
loading: "Chargement",
removePhoto: "Supprimer la photo",
clearSelectedContact: "Effacer le contact sélectionné",
selectNamed: "Sélectionner {{name}}",
removeStep: "Supprimer l’étape",
removeFilter: "Supprimer le filtre",
previousMonth: "Mois précédent",
nextMonth: "Mois suivant",
removeRelationship: "Supprimer la relation",
zoomIn: "Zoom avant",
zoomOut: "Zoom arrière",
resetView: "Réinitialiser la vue",
unlinkContact: "Dissocier le contact",
removeCharge: "Supprimer les frais",
removeLineItem: "Supprimer la ligne",
mapUnavailable: "Carte indisponible sur cet appareil",
},
actions: {
  undo: "Annuler",
cancel: "Annuler",
keep: "Conserver",
search: "Rechercher",
takePhoto: "Prendre une photo",
chooseFromGallery: "Choisir depuis la galerie",
chooseFile: "Choisir un fichier",
dismiss: "Ignorer",
tryAgain: "Réessayer",
saveChanges: "Enregistrer les modifications",
saving: "Enregistrement…",
},
createVerbs: {
guide: "Guidez-moi",
inspection: "Démarrer une inspection",
job: "Créer une intervention",
report: "Signaler un problème",
asset: "Ajouter un actif",
site: "Ajouter un site",
contact: "Ajouter un contact",
share: "Partager l’actif",
template: "Créer une check-list",
recurringJobs: "Plans de maintenance",
document: "Ajouter un document",
meterReading: "Enregistrer un relevé",
maintenancePlan: "Ajouter un plan de maintenance",
knowledge: "Ajouter une connaissance",
relationship: "Ajouter une relation",
assignAsset: "Affecter un actif",
move: "Déplacer l’actif",
childSite: "Ajouter un site enfant",
conditionReport: "Rapport d’actif",
siteReport: "Site 360",
},
createNouns: {
  guide: "Guidez-moi",
  asset: "Actif",
  inspection: "Inspection",
  job: "Intervention",
  report: "Signaler une anomalie",
  maintenancePlan: "Maintenance",
  contact: "Contact",
  site: "Site",
  template: "Check-list",
},
actVerbs: {
  guide: "Guidez-moi",
  inspection: "Inspecter",
  job: "Intervention",
  report: "Signaler",
  share: "Partager",
  document: "Ajouter doc.",
  meterReading: "Relevé",
  maintenancePlan: "Ajouter un plan",
  contact: "Contact",
  relationship: "Lier un actif",
  knowledge: "Ajouter un article",
  move: "Déplacer",
  conditionReport: "Rapport d’actif",
  asset: "Ajouter actif",
  assignAsset: "Affecter",
  childSite: "Sous-site",
  siteReport: "Site 360",
},
actVerbsA11y: {
  guide: "Me guider pour {{name}}",
  inspection: "Démarrer une inspection de {{name}}",
  job: "Créer une intervention pour {{name}}",
  report: "Signaler une anomalie sur {{name}}",
  share: "Partager {{name}}",
  document: "Ajouter un document à {{name}}",
  meterReading: "Enregistrer un relevé pour {{name}}",
  maintenancePlan: "Créer un plan de maintenance pour {{name}}",
  contact: "Ajouter un contact à {{name}}",
  relationship: "Ajouter une relation pour {{name}}",
  knowledge: "Ajouter une connaissance à {{name}}",
  move: "Déplacer {{name}}",
  conditionReport: "Générer un rapport d’actif pour {{name}}",
  asset: "Ajouter un actif à {{name}}",
  assignAsset: "Affecter un actif à {{name}}",
  childSite: "Ajouter un site enfant sous {{name}}",
  siteReport: "Rapport Site 360 pour {{name}}",
},
actionsMenuTitle: "Actions",
actionGroups: {
  help: "Aide",
  work: "Travail",
  record: "Enregistrer",
  manage: "Gérer",
  insight: "Analyse",
},
createFabA11y: "Créer — {{verbs}}",
capabilityLocked: {
tryPlanFree: "Essayer {{plan}} gratuitement",
  thisFeature: "Cette fonctionnalité",
  notInCurrentPlan: "Non inclus dans votre forfait {{plan}}",
  notInPlan: "Non inclus dans votre forfait",
  includedFrom: "Inclus à partir du forfait {{plan}}",
  includedHigher: "Inclus dans un forfait supérieur",
  internalEdition: "Cet espace de travail est sur l'édition interne Developer. Activez la fonction pour Developer dans Admin, Matrix.",
  noPlanIncludes: "Indisponible dans tous les forfaits pour le moment",
  viewPlans: "Voir les forfaits",
  openBilling: "Ouvrir Facturation et utilisation",
  viewPlansFor: "Voir les forfaits qui incluent {{feature}}",
  askOwner: "Demandez au propriétaire de votre espace de travail de changer de forfait.",
  managedOnWeb: "Disponible avec le forfait {{plan}} — choisissez-le dans Facturation et utilisation.",
  managedOnWebUnnamed: "Les forfaits se choisissent dans Facturation et utilisation.",
  badge: "Changer de forfait pour l’utiliser",
  betaTitle: "{{name}} est en bêta",
  betaDescription: "Rejoignez le programme bêta pour l’essayer en avant-première.",
  betaAction: "Demander l’accès",
  adminTitle: "{{name}} est désactivée",
  adminDescription: "Elle est désactivée pour cet espace de travail. Contactez le support AssetWRX pour l’activer.",
  dependencyTitle: "{{name}} nécessite une autre fonctionnalité",
  dependencyDescription: "Une fonctionnalité dont elle dépend est désactivée. Activez-la d’abord.",
  unavailableTitle: "{{name}} n’est pas disponible",
  unavailableDescription: "Cette fonctionnalité n’est pas disponible pour votre espace de travail.",
},
kpi: {
  of: "sur",
  partial: "partiel",
},
languageNames: {
  "ar": "العربية",
  "de-DE": "Deutsch (Deutschland)",
  "en-AU": "English (Australia)",
  "en-GB": "English (UK)",
  "en-US": "English (US)",
  "es-ES": "Español (España)",
  "fr-FR": "Français (France)",
},
createMenuTitle: "Créer",
detailActions: {
more: "Plus",
moreActions: "Autres actions",
short: {
inspect: "Inspecter",
addJob: "Intervention",
issue: "Signaler une anomalie",
share: "Partager",
document: "Document",
relate: "Associer",
contact: "Contact",
insights: "Analytique",
},
sections: {
bringWorkIn: "Recueillir les demandes",
doTheWork: "Réaliser le travail",
records: "Enregistrements",
aiAndGuidance: "IA et assistance",
},
},
alerts: {
errorTitle: "Erreur",
requiredTitle: "Obligatoire",
permissionRequiredTitle: "Autorisation requise",
signInRequiredTitle: "Connexion requise",
},
labels: {
id: "ID",
allTypes: "Tous les types",
fileSelected: "Fichier sélectionné",
},
search: {
defaultPlaceholder: "Rechercher",
clear: "Effacer la recherche",
},
searchableList: {
searchPlaceholder: "Rechercher…",
clearSearch: "Effacer la recherche",
all: "Tous",
remove: "Retirer {{label}}",
clear: "Effacer",
noMatches: "Aucun résultat.",
more_one: "{{count}} de plus — affinez votre recherche pour le voir.",
more_other: "{{count}} de plus — affinez votre recherche pour les voir.",
more_many: "{{count}} de plus — affinez votre recherche pour les voir.",
},
counts: {
item_one: "{{count}} élément",
item_other: "{{count}} éléments",
item_many: "{{count}} éléments",
mappedAssetsShowing_one: "{{count}} actif affiché sur la carte. Masqués faute de coordonnées : {{hidden}}.",
mappedAssetsShowing_many: "{{count}} d’actifs affichés sur la carte. Masqués faute de coordonnées : {{hidden}}.",
mappedAssetsShowing_other: "{{count}} actifs affichés sur la carte. Masqués faute de coordonnées : {{hidden}}.",
itemsCaptureEvidence_one: "{{count}} élément recueille actuellement au moins un type de preuve.",
itemsCaptureEvidence_many: "{{count}} d’éléments recueillent actuellement au moins un type de preuve.",
itemsCaptureEvidence_other: "{{count}} éléments recueillent actuellement au moins un type de preuve.",
importFileSummary: "{{file}} · {{rows}} · {{columns}}",
importRows_one: "{{count}} ligne de données",
importRows_many: "{{count}} de lignes de données",
importRows_other: "{{count}} lignes de données",
importColumns_one: "{{count}} colonne",
importColumns_many: "{{count}} de colonnes",
importColumns_other: "{{count}} colonnes",
autoMapColumns_one: "Associer automatiquement {{count}} colonne par nom",
autoMapColumns_many: "Associer automatiquement {{count}} de colonnes par nom",
autoMapColumns_other: "Associer automatiquement {{count}} colonnes par nom",
importPreviewRows_one: "Aperçu de {{shown}} ligne sur {{count}}. Les lignes valides affichent les valeurs exactes qui seront importées ; les lignes non valides affichent les erreurs et les valeurs lues dans les cellules.",
importPreviewRows_many: "Aperçu des {{shown}} premières lignes sur {{count}}. Les lignes valides affichent les valeurs exactes qui seront importées ; les lignes non valides affichent les erreurs et les valeurs lues dans les cellules.",
importPreviewRows_other: "Aperçu des {{shown}} premières lignes sur {{count}}. Les lignes valides affichent les valeurs exactes qui seront importées ; les lignes non valides affichent les erreurs et les valeurs lues dans les cellules.",
applyRows_one: "Appliquer {{count}} ligne",
applyRows_many: "Appliquer {{count}} de lignes",
applyRows_other: "Appliquer {{count}} lignes",
automationsReady_one: "{{count}} automatisation prête",
automationsReady_many: "{{count}} d’automatisations prêtes",
automationsReady_other: "{{count}} automatisations prêtes",
aiFollowUpsReady_one: "{{count}} suivi rédigé par l’IA prêt",
aiFollowUpsReady_many: "{{count}} de suivis rédigés par l’IA prêts",
aiFollowUpsReady_other: "{{count}} suivis rédigés par l’IA prêts",
extractedItemsFound_one: "{{count}} ligne trouvée. Modifiez-la ou décochez-la avant de l’ajouter à l’intervention.",
extractedItemsFound_many: "{{count}} de lignes trouvées. Modifiez-les ou décochez-les avant de les ajouter à l’intervention.",
extractedItemsFound_other: "{{count}} lignes trouvées. Modifiez-les ou décochez-les avant de les ajouter à l’intervention.",
addItems_one: "Ajouter {{count}} ligne",
addItems_many: "Ajouter {{count}} de lignes",
addItems_other: "Ajouter {{count}} lignes",
},
teamMemberRole: {
owner: "Propriétaire",
admin: "Administrateur",
member: "Membre",
},
teamSummary: {
memberCount_one: "{{count}} membre",
memberCount_many: "{{count}} membres",
memberCount_other: "{{count}} membres",
pendingInvites_one: "{{count}} invitation en attente",
pendingInvites_many: "{{count}} invitations en attente",
pendingInvites_other: "{{count}} invitations en attente",
expiredInvites_one: "{{count}} invitation expirée",
expiredInvites_many: "{{count}} invitations expirées",
expiredInvites_other: "{{count}} invitations expirées",
twoFactorOn: "2FA activée",
twoFactorOff: "2FA désactivée",
youSuffix: "(vous)",
skillsLoading: "Compétences : chargement…",
noSkills: "Aucune compétence enregistrée — touchez pour ajouter",
skillCount_one: "{{count}} compétence",
skillCount_many: "{{count}} compétences",
skillCount_other: "{{count}} compétences",
editSkillsA11y: "Modifier les compétences de {{name}}",
},
teamMemberAction: {
askAdmin: "Demander à le nommer administrateur",
changeToAdmin: "Passer administrateur",
changeToMember: "Passer membre",
requestSentTitle: "Demande envoyée",
requestSentBody: "Le propriétaire de l’équipe devra approuver {{name}} comme administrateur.",
roleChangeFailed: "Impossible de modifier le rôle",
removeFailed: "Impossible de retirer le membre",
decideFailed: "Impossible d’enregistrer votre décision",
pendingTitle: "En attente de votre approbation",
pendingTitleAdmin: "En attente du propriétaire",
pendingRow: "Nommer {{name}} administrateur ? Demandé par {{requester}}.",
approve: "Approuver",
decline: "Refuser",
requestedPill: "Administrateur demandé",
},
embedNotice: {
  viewOnly: "Lecture seule : ce portail vous permet de consulter les fiches, pas de les modifier.",
  loading: "Ouverture d'AssetWRX…",
  reload: "Recharger la page",
  expiredBody: "La connexion a pris plus de temps que cette page ne le permet. Rechargez la page pour entrer directement.",
  expiredTitle: "Rechargez pour continuer",
pageTitle: "Vue intégrée",
unsupportedTitle: "Non disponible ici",
unsupportedBody: "Cette partie d'AssetWRX n'est pas incluse dans cette vue intégrée.",
goBack: "Retour",
openInAssetWrx: "Ouvrir dans AssetWRX",
unavailableTitle: "L'intégration est désactivée",
unavailableBody: "AssetWRX intégré ne fait pas partie de l'offre de cet espace de travail. Demandez au propriétaire de votre espace AssetWRX de changer d'offre.",
deniedTitle: "Impossible d'ouvrir cette vue",
deniedBody: "Ce portail n'est pas autorisé à ouvrir AssetWRX pour vous ici. Demandez à votre administrateur AssetWRX de vérifier l'application intégrée.",
endedTitle: "Session terminée",
endedBody: "Cette session AssetWRX intégrée est terminée. Rechargez la page pour en démarrer une nouvelle.",
sessionRequiredTitle: "Ouvrez-la depuis votre portail",
sessionRequiredBody: "Cette vue AssetWRX ne peut être affichée que par un portail approuvé. Ouvrez-la depuis celui-ci.",
ssoDeniedTitle: "Utilisez le compte de votre organisation",
ssoDeniedBody: "Ce portail exige une connexion avec le compte Microsoft de votre organisation. Rechargez la page pour réessayer.",
},
tourStep: "Étape {{current}} sur {{total}}",
guideFlow: {
  pages: {
    assets: "Actifs",
    inspections: "Inspections",
    requests: "Demandes",
    jobs: "Interventions",
    reports: "Rapports",
    contacts: "Contacts",
    contractors: "Entrepreneurs",
  },
  ui: {
    open: "Ouvrir {{page}}",
    howItWorks: "Comment ça marche",
    comesInFrom: "Arrive par",
    feeds: "Alimente {{stage}}",
    tapAgain: "Touchez à nouveau pour ouvrir.",
    subtitle: "La boucle du quotidien, de bout en bout. Survolez ou touchez une étape, puis ouvrez sa page.",
    stageA11y: "{{num}}. {{label}}. {{caption}}. Ouvre {{page}}.",
    inputA11y: "{{label}}. Alimente {{stage}}. Ouvre {{page}}.",
  },
  "add-your-first-asset": {
    label: "Ajouter des actifs",
    caption: "Enregistrez vos biens",
  },
  "run-an-inspection": {
    label: "Inspecter",
    caption: "État et preuves",
  },
  "report-an-issue": {
    label: "Signaler",
    caption: "Chacun signale un problème",
  },
  "create-a-job": {
    label: "Réaliser",
    caption: "Commandez et suivez",
  },
  "share-a-report": {
    label: "Valider et partager",
    caption: "Bouclez la boucle",
  },
  "public-intake-qr": {
    label: "Signalement QR public",
  },
  "share-for-requests": {
    label: "Demandeurs partagés",
  },
  "add-a-contractor": {
    label: "Prestataires",
  },
},
notFound: {
stackTitle: "Introuvable",
title: "Page introuvable",
goHome: "Retour à l'accueil",
body: "Le lien est peut-être obsolète, ou la page a été déplacée.",
},
compact: {
  minutes: "{{n}} min",
  hours: "{{n}} h",
  days: "{{n}} j",
  now: "à l’instant",
  justNow: "à l’instant",
  yesterday: "hier",
  tomorrow: "Demain",
},
relative: {
  today: "Aujourd’hui",
  tomorrow: "Demain",
  daysAgo: "il y a {{n}} j",
  yesterday: "Hier",
  hoursAgo: "il y a {{n}} h",
  minutesAgo: "il y a {{n}} min",
  justNow: "À l’instant",
deadlinePassed: "Échéance dépassée",
daysLeft_one: "Il reste {{count}} jour",
daysLeft_other: "Il reste {{count}} jours",
hoursLeft_one: "Il reste {{count}} heure",
hoursLeft_other: "Il reste {{count}} heures",
minutesLeft_one: "Il reste {{count}} minute",
minutesLeft_other: "Il reste {{count}} minutes",
daysLeft_many: "Il reste {{count}} jours",
hoursLeft_many: "Il reste {{count}} heures",
minutesLeft_many: "Il reste {{count}} minutes",
},
errors: {
  unreachable: "Impossible de joindre le serveur. Vérifiez que vous êtes en ligne, puis réessayez.",
  notThrough: "L’opération n’a pas abouti. Veuillez réessayer.",
  workspaceUnavailable: "Impossible de charger votre espace de travail. Vérifiez que vous êtes en ligne, puis réessayez.",
  summaryAuthorOnly: "Seule la personne qui a réalisé cette inspection, ou un administrateur de l'espace de travail, peut modifier son résumé, et seulement avant sa validation.",
  assetNotEditable: "Vous ne pouvez pas modifier l'un de ces actifs.",
  templateNotEditable: "Vous ne pouvez pas modifier les personnes avec qui cette check-list est partagé.",
  deleteApproved: "Une inspection approuvée ne peut pas être supprimée : elle fait partie du registre de conformité.",
  cancelApproved: "Une inspection approuvée ne peut pas être annulée.",
  requiredItemsIncomplete: "Chaque élément obligatoire doit avoir une réponse ou être ignoré avant de pouvoir terminer cette inspection.",
  quoteRequestClosed: "Cette demande de devis est close. Elle a été attribuée, a dépassé sa date limite ou a été retirée.",
  postcheckRequired: "Une vérification obligatoire doit être effectuée avant l'envoi de cette intervention.",
  evidenceRequired: "Une photo ou une vidéo du travail terminé est requise. Ajoutez-la à cette intervention ou à l'une de ses sous-interventions, puis réessayez.",
  precheckRequired: "Une prévérification doit être effectuée avant le début de cette intervention.",
  jobHandedOff: "Cette intervention a été confiée à quelqu’un d’autre. Réattribuez-la ou reprenez-la pour la modifier.",
  jobOutForQuotes: "Cette intervention est chez des prestataires pour devis. Choisissez un devis ou fermez la demande pour la modifier.",
  inspectionHandedOff: "Cette inspection a été confiée à quelqu’un d’autre. Seule cette personne peut y répondre.",
  retireOpenWork: "Cet actif a encore des travaux en cours. Terminez-les ou annulez-les avant de le retirer définitivement.",
  templateInUseBySchedules: "Cette check-list est encore utilisé par des inspections planifiées à venir. Annulez d'abord ces planifications.",
  approveOverseerOnly: "Seuls le propriétaire, l'approbateur ou l'équipe de l'actif peuvent valider cette inspection, et l'inspecteur ne peut pas valider son propre travail.",
  waiverAdminOnly: "Seul un administrateur de l'espace de travail peut lever un constat.",
  restoreAdminOnly: "Seul un administrateur de l'espace de travail peut restaurer un actif retiré définitivement.",
  retireOwnerOrAdmin: "Seul le propriétaire de l'actif ou un administrateur de l'espace de travail peut le retirer définitivement.",
  assetRetired: "Cet actif a été retiré définitivement et n'accepte plus de nouvelles inspections ni interventions.",
  workspaceReadOnly: "Cet espace de travail est en lecture seule. Choisissez un forfait dans Facturation pour continuer à ajouter et modifier.",
  assetPlanLimit: "Vous avez atteint la limite d'actifs de votre forfait. Un forfait supérieur permet d'en ajouter davantage.",
  capabilityUnavailable: "Cette fonctionnalité n'est pas incluse dans votre forfait. Choisissez un forfait dans Facturation pour l'utiliser.",
  assetSubscriptionRequired: "Votre espace de travail a utilisé les actifs gratuits de son forfait. Démarrez un abonnement pour ajouter d'autres actifs.",
  assetChanged: "Cet actif a changé depuis que vous l'avez ouvert. Rechargez-le, puis réessayez.",
  onlineRequired: "Rétablissez la connexion Internet pour terminer cette action. Les informations saisies resteront ici.",
  jobUpdateRefused: "Cette intervention n'a pas pu être mise à jour depuis votre compte. Elle a peut-être été réattribuée ou clôturée. Actualisez, puis réessayez.",
  jobChanged: "Cette intervention a changé depuis que vous l'avez ouverte. Rechargez-la, puis réessayez.",
  sessionExpired: "Votre session a expiré. Reconnectez-vous.",
  alreadyExists: "Cet élément existe déjà. Utilisez une autre valeur ou modifiez l'élément existant.",
  configMismatch: "L'application n'a pas pu terminer cette action. Réessayez ou contactez l'assistance si le problème persiste.",
  valueNotAllowed: "L'une des valeurs n'est pas autorisée. Vérifiez votre saisie, puis réessayez.",
  network: "La connexion est lente ou coupée. Veuillez réessayer.",
  requiredMissing: "Un champ obligatoire est vide. Remplissez toutes les informations obligatoires.",
  noPermission: "Vous n'avez pas l'autorisation de faire cela.",
  missingReference: "Un élément nécessaire à cette action a été supprimé. Actualisez, puis réessayez.",
  notFound: "Cet élément est introuvable. Il a peut-être été supprimé.",
  fallback: "Une erreur est survenue. Veuillez réessayer.",
generic: "Une erreur est survenue.",
},
resilience: {
capability_disabled: {
title: "Cette fonctionnalité est indisponible",
body: "Votre organisation n’a pas activé cette fonctionnalité. Contactez un administrateur si nécessaire.",
},
permission_denied: {
title: "Vous n’avez pas l’autorisation",
body: "Votre rôle actuel ne permet pas cette action. Votre travail existant n’a pas été modifié.",
},
read_only: {
title: "Accès en lecture seule",
body: "Vous pouvez consulter ces informations, mais votre rôle ne permet pas de les modifier.",
},
resource_unavailable: {
title: "Cet élément n’est plus disponible",
body: "Il a peut-être été supprimé ou votre accès a changé. Ouvrez l’activité pour continuer en toute sécurité.",
action: "Ouvrir l’activité",
},
online_required: {
title: "Connexion Internet requise",
body: "Rétablissez la connexion Internet et réessayez. Les informations saisies resteront disponibles sur cet appareil.",
},
},
sorting: {
sortBy: "Trier par",
newest: "Plus récent d’abord",
oldest: "Plus ancien d’abord",
last_updated: "Dernière mise à jour",
name_az: "Nom A–Z",
name_za: "Nom Z–A",
priority_high: "Priorité haute → basse",
priority_low: "Priorité basse → haute",
due_soonest: "Échéance la plus proche",
due_latest: "Échéance la plus lointaine",
overdue_first: "En retard d’abord",
recently_active: "Récemment actif",
status: "Statut",
condition_score: "Score d’état",
health_score: "Score de santé",
risk_score: "Score de risque",
compliance_score: "Score de conformité",
last_inspection: "Dernière inspection",
completed_date: "Date d’achèvement",
assigned_to: "Assigné à",
scheduled_date: "Date planifiée",
inspection_score: "Score d’inspection",
requested_date: "Date de demande",
approval_status: "Statut d’approbation",
},
scanCapture: {
openSettings: "Ouvrir les réglages",
cameraBlockedMessage: "L’accès à l’appareil photo est désactivé pour AssetWRX. Activez-le dans les réglages ou utilisez plutôt une photo.",
signInRequiredBody: "Veuillez vous connecter pour lire une photo avec l'IA.",
aiOfflineStatus: "La lecture par IA sera disponible lorsque vous serez de nouveau en ligne. Votre photo est toujours là.",
readingWithAiStatus: "Lecture de la photo avec l’IA…",
couldNotReadPhotoTitle: "Impossible de lire la photo",
tryAgain: "Veuillez réessayer.",
noIdentifierReadable: "Aucun VIN ou numéro de série n'était lisible sur cette photo. Réessayez ou saisissez-le manuellement.",
permissionRequiredTitle: "Autorisation requise",
grantLibraryBody: "Veuillez autoriser l'accès à la photothèque.",
readingPhotoStatus: "Lecture de la photo…",
couldNotReadOnDeviceWeb: "Entrez la valeur ci-dessous ou lisez la photo avec l'IA.",
couldNotReadOnDeviceNative: "Impossible de le lire sur cet appareil. Entrez la valeur ci-dessous ou lisez la photo avec l'IA.",
enterAValueTitle: "Entrez une valeur",
enterAValueBody: "Veuillez coller ou saisir une valeur.",
readWithAiLabel: "Lisez la photo avec l'IA. Coûte {{cost}}.",
readWithAiText: "Lire avec l'IA ({{cost}})",
scanQrTitle: "Scanner le code QR",
scanIdentifierTitle: "Scanner le VIN / numéro de série",
webUnavailableMessage: "La numérisation par caméra n’est pas disponible sur le Web. Collez une valeur ou choisissez une photo de l'étiquette pour la lire.",
identifierInputLabel: "VIN ou numéro de série",
identifierPlaceholder: "Coller ou taper VIN / série…",
useThisValue: "Utiliser cette valeur",
pickPhotoOfLabel: "Choisissez une photo de l'étiquette",
requestingCameraPermission: "Demande d'autorisation de la caméra…",
cameraPermissionRequiredTitle: "Autorisation de la caméra requise",
cameraPermissionMessage: "L'accès à la caméra est nécessaire pour numériser. Vous pouvez également lire une étiquette à partir d'une photo enregistrée.",
grantPermission: "Accorder l'autorisation",
usePhotoInstead: "Utilisez plutôt une photo",
closeScanner: "Fermer le scanner",
readingEllipsis: "Lecture…",
positionQrHint: "Positionner le code QR dans le cadre",
positionBarcodeHint: "Pointez sur le code-barres ou touchez le déclencheur pour lire l'étiquette à partir d'une photo",
takePhotoOfLabel: "Prendre une photo de l'étiquette",
photo: "Photo",
library: "Photothèque",
holdStill: "Ne bougez pas…",
glareHint: "Reflet sur la plaque : inclinez légèrement le téléphone ou mettez la plaque à l’ombre, puis réessayez.",
darkHint: "Trop sombre pour lire : allumez la lampe ou trouvez un meilleur éclairage, puis réessayez.",
},
cameraControls: {
noZoom: "1×",
zoomPercent: "{{percent}} %",
zoomOut: "Dézoomer",
zoomIn: "Zoomer",
resetZoom: "Réinitialiser le zoom",
zoomValueA11y: "Zoom à {{percent}} pour cent",
lightOn: "Allumer la lampe",
lightOff: "Éteindre la lampe",
},
cookieBanner: {
title: "Les cookies sur AssetWRX",
bodyBeforeLink: "Nous utilisons des cookies strictement nécessaires au fonctionnement d'AssetWRX. Avec votre consentement, nous utiliserons également des cookies pour comprendre comment l'application est utilisée et pour mesurer les campagnes marketing. Vous pouvez changer d'avis à tout moment dans",
bodyCompact: "Cookies nécessaires uniquement, sauf si vous autorisez ceux d’analyse et de marketing. Détails dans la",
cookiePolicyLink: "Politique relative aux cookies",
rejectAll: "Tout rejeter",
managePreferences: "Gérer les préférences",
acceptAll: "Accepter tout",
preferencesTitle: "Préférences en matière de cookies",
strictlyNecessaryTitle: "Strictement nécessaire",
alwaysOn: "Toujours actifs",
strictlyNecessaryBody: "Connexion, sécurité et fonctionnalités essentielles.",
analyticsTitle: "Analyse",
analyticsBody: "Événements d'utilisation anonymes qui nous aident à améliorer AssetWRX.",
marketingTitle: "Marketing",
marketingBody: "Mesure des performances des campagnes. Nous ne vendons jamais vos données.",
back: "Retour",
savePreferences: "Enregistrer les préférences",
},
analyticsPrompt: {
title: "Aidez-nous à améliorer AssetWRX",
body: "Partagez des données d’utilisation (les écrans que vous utilisez et vos appuis, jamais ce que vous saisissez) pour que nous rendions l’application plus rapide et plus simple. Vous pouvez modifier ce choix à tout moment dans Compte → Confidentialité et données → Préférences de communication.",
allow: "Autoriser",
notNow: "Pas maintenant",
},
webContactsList: {
sort: {
name_asc: "Nom A–Z",
name_desc: "Nom Z–A",
updated_desc: "Mis à jour récemment",
},
allRoles: "Tous",
filterByRoleA11y: "Filtrer les contacts par rôle",
roleA11y: "Rôle : {{role}}",
moreFiltersA11y: "Plus de filtres : tous les types de rôles et réinitialisation",
more: "Plus…",
visibilityScopeA11y: "Portée de visibilité",
scopeAllA11y: "Portée : tout",
scopeTeamA11y: "Portée : équipe",
scopeAccountA11y: "Portée : compte",
scopeAllLabel: "Toutes les portées",
scopeTeamLabel: "Équipe",
scopeAccountLabel: "Compte",
sortContactsA11y: "Trier les contacts",
sortA11y: "Trier : {{sort}}",
importContactsA11y: "Importer des contacts",
import: "Importer",
columns: {
name: "Nom",
scope: "Portée",
roles: "Rôles",
organisation: "Organisation",
contact: "E-mail / téléphone",
skills: "Compétences",
},
},
qrLabelPrint: {
defaultTitle: "Imprimer les étiquettes QR",
noAssetsTitle: "Aucun actif",
noAssetsBody: "Sélectionnez au moins un actif pour imprimer des étiquettes.",
noQrCodesTitle: "Pas de codes QR",
noQrCodesBody: "Les actifs sélectionnés n'ont pas encore de code QR.",
labelsPrepared_one: "{{count}} étiquette préparée.",
labelsPrepared_other: "{{count}} étiquettes préparées.",
assetsSkipped_one: "{{count}} actif ignoré (code QR manquant).",
assetsSkipped_other: "{{count}} actifs ignorés (code QR manquant).",
labelsUsedFallback_one: "{{count}} étiquette a utilisé le code AssetWRX (aucun numéro de série enregistré).",
labelsUsedFallback_other: "{{count}} étiquettes ont utilisé le code AssetWRX (aucun numéro de série enregistré).",
labelsReadyTitle: "Étiquettes prêtes",
printFailedTitle: "Échec de l'impression",
printFailedBody: "Impossible de générer des étiquettes.",
selectedAssetsLabel: "Actifs sélectionnés",
selectedAssetsValue_one: "{{count}} sélectionné ({{withQr}} avec code QR)",
selectedAssetsValue_many: "{{count}} sélectionnés ({{withQr}} avec code QR)",
selectedAssetsValue_other: "{{count}} sélectionnés ({{withQr}} avec code QR)",
templateLabel: "Check-list",
qrContentsLabel: "Contenu du QR",
serialCoverageNote: "{{withSerial}} sur {{total}} ont un numéro de série ; les autres utilisent le code AssetWRX.",
scanActionLabel: "Action lors du scan",
includeMetadataToggle: "Inclure de courtes métadonnées sur les étiquettes",
cancel: "Annuler",
printLabels: "Imprimer les étiquettes",
labelsPrepared_many: "{{count}} étiquettes préparées.",
assetsSkipped_many: "{{count}} actifs ignorés (code QR manquant).",
labelsUsedFallback_many: "{{count}} étiquettes ont utilisé le code AssetWRX (aucun numéro de série enregistré).",
},
reportReview: {
  stillToDecide_other: "{{count}} éléments attendent encore une décision. Lisez les constats ci-dessous, puis décidez dans Vos décisions, plus haut.",
  stillToDecide_many: "{{count}} éléments attendent encore une décision. Lisez les constats ci-dessous, puis décidez dans Vos décisions, plus haut.",
  stillToDecide_one: "{{count}} élément attend encore une décision. Lisez les constats ci-dessous, puis décidez dans Vos décisions, plus haut.",
  gate: {
    notYouBody: "Indiquez votre lien avec ce bien. L'équipe qui le gère décide si vous pouvez voir le rapport.",
    notYouLink: "Vous n'êtes pas le destinataire ? Demander l'accès",
    useDifferentAccount: "Utiliser un autre compte",
    signedInAs: "Connecté en tant que {{email}}. Ce rapport a été envoyé à une autre adresse e-mail.",
    notYouSignedOut: "Vous n'êtes pas le destinataire ? Connectez-vous, puis appuyez sur Demander l'accès.",
    signedOutBody: "Ce rapport vous a été envoyé ? Connectez-vous avec l'adresse e-mail à laquelle il a été envoyé et il s'ouvre aussitôt.",
    requestAccess: "Demander l'accès",
    sendFailedTitle: "Impossible d'envoyer la demande",
    roleManager: "Gestionnaire ou agent immobilier",
    outcomeClear: "Aucun problème relevé",
    outcomeAttention: "À surveiller",
    outcomeAction: "Action requise",
    askSender: "Demandez à la personne qui l'a envoyé de renvoyer le lien.",
  },
  jobs: {
    count_other: "{{count}} interventions",
    count_many: "{{count}} interventions",
    count_one: "{{count}} intervention",
    estimatedCost: "Estimé : {{amount}}",
    approvedCost: "Approuvé : {{amount}}",
    started: "Commencée le {{date}}",
    scheduled: "Prévue le {{date}}",
    assignedTo: "Assignée à {{name}}",
    cancelled: "Annulées : {{n}}",
    inProgress: "En cours : {{n}}",
    completed: "Terminées : {{n}}",
  },
  done: {
    senderRepairs_other: "{{count}} réparations approuvées. Appuyez sur Créer des interventions dans l'inspection pour les planifier.",
    senderRepairs_many: "{{count}} réparations approuvées. Appuyez sur Créer des interventions dans l'inspection pour les planifier.",
    senderRepairs_one: "{{count}} réparation approuvée. Appuyez sur Créer des interventions dans l'inspection pour la planifier.",
    repairsApproved_other: "Vous avez approuvé {{count}} réparations. L'équipe est prévenue et peut en faire des interventions.",
    repairsApproved_many: "Vous avez approuvé {{count}} réparations. L'équipe est prévenue et peut en faire des interventions.",
    repairsApproved_one: "Vous avez approuvé {{count}} réparation. L'équipe est prévenue et peut en faire une intervention.",
    allMarked: "Tous les éléments sont marqués approuvés. Refusez ceux que vous ne voulez pas, puis signez et appuyez sur Approuver.",
    changesRequested: "Vous avez demandé des modifications. {{company}} a reçu votre remarque.",
    allDeclined: "Vous avez approuvé le rapport et refusé toutes les réparations. L'équipe a vos remarques.",
    approved: "Vous avez approuvé ce rapport. L'équipe a été prévenue.",
  },
  signOff: {
    decideFirst_other: "Décidez d'abord chaque élément (il en reste {{count}})",
    decideFirst_many: "Décidez d'abord chaque élément (il en reste {{count}})",
    decideFirst_one: "Décidez d'abord chaque élément (il en reste {{count}})",
    sendBackPlaceholder: "Que faut-il modifier ? (obligatoire)",
    sendBack: "Renvoyer",
    promptDecideFirst: "Appuyez d'abord sur Approuver ou Refuser pour chaque élément ci-dessus. Vous pouvez appuyer sur Renvoyer à tout moment.",
    promptReady: "Signez pour valider. L'équipe est prévenue et peut transformer les réparations approuvées en interventions.",
    promptNoItems: "Lisez le rapport. Puis signez pour valider, ou appuyez sur Renvoyer pour demander des modifications.",
    sendToTeam: "Envoyer à l'équipe",
    signatureLabel: "Signez ici",
    recordsOnly: "Ce rapport est pour vos archives.",
    changesMessage: "Vous avez demandé des modifications",
    approvedMessage: "Vous avez approuvé. Merci.",
    changesPlaceholder: "Qu'est-ce qui doit être repris ?",
    requestChanges: "Demander des modifications",
    approve: "Valider",
    prompt: "Vérifiez le travail, puis approuvez-le ou demandez des modifications.",
    title: "Votre décision",
  },
  insight: {
    itemsIncluded_other: "{{count}} éléments dans ce rapport.",
    itemsIncluded_many: "{{count}} éléments dans ce rapport.",
    itemsIncluded_one: "{{count}} élément dans ce rapport.",
    senderWaitingItems_other: "En attente de la décision de {{name}} sur {{count}} éléments.",
    senderWaitingItems_many: "En attente de la décision de {{name}} sur {{count}} éléments.",
    senderWaitingItems_one: "En attente de la décision de {{name}} sur {{count}} élément.",
    toDecide_other: "{{count}} éléments attendent votre décision avant l'approbation.",
    toDecide_many: "{{count}} éléments attendent votre décision avant l'approbation.",
    toDecide_one: "{{count}} élément attend votre décision avant l'approbation.",
    sourceLabel: "les éléments de ce rapport",
    actionSenderWait: "La personne qui l'a envoyé reçoit une notification à la réponse.",
    actionTrackJobs: "Suivez ci-dessous les interventions créées à partir de ce rapport.",
    actionApprove: "Signez et appuyez sur Approuver. L'équipe est prévenue aussitôt.",
    actionDecide: "Appuyez sur Approuver ou Refuser pour chaque élément.",
    metricNotDecided: "Non décidés",
    metricToDecide: "À décider",
    checkFirst: "À vérifier avant de décider : {{list}}.",
    duplicates: "Doublons possibles : {{n}}",
    noPhotos: "Sans photo : {{n}}",
    urgent: "Urgents : {{n}}",
    decisionCounts: "Approuvés : {{approved}} · Refusés : {{declined}} · Non décidés : {{pending}}",
    senderWaiting: "En attente de l'approbation de {{name}}.",
    senderChangesNoReason: "{{name}} a demandé des modifications.",
    senderChanges: "{{name}} a demandé des modifications : « {{reason}} »",
    senderApprovedNoDate: "{{name}} a approuvé ce rapport.",
    senderApproved: "{{name}} a approuvé ce rapport le {{date}}.",
    nothingToDecide: "Rien à décider ici. Lisez le rapport, puis appuyez sur Approuver ou Renvoyer.",
    youApproved: "Vous avez approuvé ce rapport.",
    youApprovedOn: "Vous avez approuvé ce rapport le {{date}}.",
    titleDone: "Revue envoyée",
    title: "Résumé de la revue",
  },
  threadEmptySender: "Écrivez à {{name}} ici. Aucun message pour l'instant.",
  threadEmptyReviewer: "Posez vos questions à l'inspecteur ici. Aucun message pour l'instant.",
  inspector: "Inspecteur",
  photoA11y: "Photo {{number}} sur {{total}} pour {{item}}",
  allDecided: "Chaque élément est décidé. Signez et appuyez sur Approuver.",
  decideAbove: "Faites votre choix dans Vos décisions, plus haut.",
  urgentFlagged: "Cet élément est marqué comme urgent.",
  urgentNow: "Urgent – à traiter maintenant",
  recommendation: "Recommandation",
  description: "Descriptif",
  ratingType: {
    condition: "État",
    level: "Niveau",
    passFlagFail: "Conforme, à signaler ou non conforme",
    passFailNa: "Conforme, non conforme ou N/A",
    yesNo: "Oui ou non",
  },
  theirDecisions: "Leurs décisions",
  reviewerFallback: "Le destinataire",
  theTeam: "L'équipe",
  otherGroup: "Autre",
  helloGreeting: "Bonjour {{name}} — {{greeting}}",
  startedOn: "Commencée le {{date}}",
  completedOn: "Terminée le {{date}}",
  inspectionFallback: "Inspection",
  openAssetA11y: "Ouvrir {{name}}",
  metaPill: "Revue du rapport",
  notYours: "Seule la personne à qui ce rapport a été envoyé peut l'approuver ou le renvoyer.",
  saveFailed: "Impossible d'enregistrer votre choix. Vérifiez votre connexion et réessayez.",
  evidenceFailed: "Impossible de charger les constats et les photos. Vérifiez votre connexion et réessayez.",
  evidenceTimeout: "L'inspection met trop de temps à se charger. Vérifiez votre connexion et réessayez.",
},
jobReportShare: {
  assetFallback: "Actif",
  recipientFallback: "Destinataire",
  jobFallback: "Intervention",
  emailSubject: "Rapport de fin d'intervention – {{jobTitle}}",
headerTitle: "Rapport de fin d'intervention",
shareLinkNotFound: "Lien de partage introuvable.",
goToAssetWrx: "Aller à AssetWRX",
signInToViewTitle: "Connectez-vous pour consulter ce rapport",
signInToViewBody: "Ce rapport d'achèvement de l'intervention a été partagé avec votre adresse e-mail. Connectez-vous – ou créez un compte gratuit avec cet e-mail – et le rapport s'ouvrira automatiquement.",
signIn: "Se connecter",
createAccount: "Créer un compte",
noAccessOrNotFound: "Lien de partage introuvable ou vous n’y avez pas accès. Si le rapport a été partagé avec une autre adresse e-mail, connectez-vous avec cette adresse pour l'ouvrir.",
tryAgain: "Réessayer",
loadingReport: "Chargement du rapport…",
loadTimeout: "Le chargement du rapport prend trop de temps. Vérifiez votre connexion et réessayez.",
loadFailed: "Impossible de charger ce rapport.",
},
qrScanFallback: {
linkToExistingAsset: "Lier à un actif existant",
title: "QR introuvable",
message: "Le code QR scanné \"{{value}}...\" ne correspond à aucun actif existant.",
createNewAsset: "Créer un nouvel actif",
createNewAssetSubtitle: "Créez un nouvel actif et associez-y ce code QR",
orLinkToExisting: "Ou lier à un actif existant",
chooseAssetPlaceholder: "Choisir un actif",
chooseAssetHint: "Choisissez l'actif auquel lier ce code QR",
linkQrCode: "Lier le code QR",
successTitle: "Réussite",
successBody: "QR lié avec succès à l'actif.",
errorTitle: "Erreur",
linkFailed: "Échec de la liaison du code QR.",
},
inboxSidebar: {
  openA11y: "Ouvrir {{title}}",
  openAction: "Ouvrir",
  snoozeFailed: "Le report n'a pas fonctionné. Vérifiez votre connexion et réessayez.",
  snoozedUntil: "Reporté jusqu'à {{time}}. Il reviendra à ce moment-là.",
groupLabel: {
high: "Besoin de vous",
medium: "Mises à jour",
low: "Pour info",
read: "Lues",
},
inboxA11y: "Notifications",
expandInbox: "Afficher les notifications",
myQueue: "Notifications",
collapseInbox: "Masquer les notifications",
allCaughtUp: "Vous êtes à jour",
noActionableNotifications: "Vous n'avez aucune notification à traiter.",
itemsCountA11y_one: "{{title}}, {{count}} élément",
itemsCountA11y_many: "{{title}}, {{count}} éléments",
itemsCountA11y_other: "{{title}}, {{count}} éléments",
snoozeA11y: "Reporter {{title}}",
markDoneA11y: "Marquer {{title}} comme terminé",
markAllRead: "Marquer tout comme lu",
seeAllInMyQueue: "Voir toutes les notifications",
seeAll: "Voir tout",
},
healthDetail: {
dismiss: "Ignorer",
assetHealth: "Santé de l'actif",
close: "Fermer",
subtitle: "La santé opérationnelle est un score de 0 à 100 basé sur les documents de conformité, les planifications et l'âge des inspections, les interventions en cours, les approbations et les résultats de l'inspection. Une note d’état d’inspection de 1 à 5 est mesurée séparément.",
notScored: "Non noté",
whatChangedScore: "Qu'est-ce qui a changé votre score",
scoreHint: "Chaque ligne contient les points retirés de 100 avant que le score ne soit plafonné entre 0 et 100.",
emptyScoreLine: "Aucun score n'est affiché car il n'y a pas d'inspections terminées, d'interventions ouvertes, d'inspections planifiées, de documents de conformité ou de demandes ouvertes pour cet actif.",
noPenaltiesLine: "Aucune pénalité par rapport aux règles actuelles : le score reste au maximum.",
flaggedItemsTitle: "Éléments signalés dans le dernier rapport",
openFindingA11y: "Ouvrir le constat : {{label}}",
positiveAdjustments: "Ajustements positifs",
recommendedActions: "Actions recommandées",
noActionsLine: "Aucune action spécifique : tenir à jour les inspections et les interventions.",
goTo: "Aller à",
quickLinkJobs: "Interventions",
quickLinkInspections: "Inspections",
quickLinkStartInspection: "Démarrer une inspection",
done: "Terminé",
},
contactInvite: {
invalidLink: "Lien d'invitation invalide",
invitationNotFound: "Invitation introuvable",
invitationExpired: "Cette invitation a expiré",
invitationInvalid: "Ce lien d'invitation n'est plus valide.",
failedToLoad: "Échec du chargement de l'invitation",
loadTimeout: "Le chargement de l'invitation prend trop de temps. Vérifiez votre connexion et réessayez.",
emailMismatchTitle: "Incohérence des e-mails",
emailMismatchBody: "Cette invitation a été envoyée à {{email}}. Veuillez vous connecter avec cet e-mail pour accepter.",
errorTitle: "Erreur",
loadingInvitation: "Chargement de l’invitation…",
invalidOrExpiredTitle: "Invalide ou expiré",
tryAgain: "Réessayer",
goBack: "Retour",
title: "Invitation de contact",
descBeforeName: "Vous avez été invité à accéder à l'application en tant que",
descAfterName: ". Cela lie votre compte au contact ; vous ne serez pas ajouté à une équipe.",
signInHint: "Connectez-vous pour accepter cette invitation",
signIn: "Se connecter",
createAccount: "Créer un compte",
signInWithDifferentEmailHint: "Cette invitation a été envoyée à {{email}}. Connectez-vous avec ce compte.",
signInWithDifferentAccount: "Se connecter avec un autre compte",
accept: "Accepter",
},
signatureField: {
defaultLabel: "Signature",
defaultHelperText: "Appuyez sur la case pour signer ; le pad s’ouvre en plein écran.",
clearSignature: "Effacer la signature",
clear: "Effacer",
signatureCapturedA11y: "Signature capturée — appuyez pour modifier",
signed: "Signé",
tapToChange: "Appuyez pour modifier",
openSignaturePadA11y: "Ouvrir le bloc-signature pour signer",
tapToSignHere: "Appuyez pour signer ici",
signHereTitle: "Signez ici",
capturedSignatureA11y: "Signature capturée",
},
invoiceCapture: {
documentLabelPdf: "PDF",
documentLabelWord: "Word",
documentLabelGeneric: "Document",
permissionRequiredTitle: "Autorisation requise",
grantCameraBody: "Veuillez accorder l'accès à l'appareil photo pour prendre une photo.",
grantLibraryBody: "Veuillez autoriser l'accès à la photothèque.",
errorTitle: "Erreur",
couldNotOpenDocumentPicker: "Impossible d'ouvrir le sélecteur de documents.",
uploadFailedTitle: "Échec du téléchargement",
failedToUploadFile: "Échec du téléchargement du fichier.",
actionSheetTakePhoto: "Prendre une photo",
actionSheetChoosePhoto: "Choisir une photo",
actionSheetChooseFile: "Choisir un fichier (PDF, Word)",
addInvoiceTitle: "Ajouter une facture",
addInvoiceBody: "Choisir une photo ou un document",
removeFileTitle: "Supprimer le fichier",
removeFileBody: "Êtes-vous sûr de vouloir supprimer ce fichier ?",
remove: "Supprimer",
removeInvoiceA11y: "Supprimer cette facture",
addInvoiceOrReceiptA11y: "Ajouter une facture ou un reçu",
},
complianceAuditDetail: {
dismiss: "Ignorer",
title: "Conformité et audit",
close: "Fermer",
subtitle: "Le score reflète les documents, les inspections, les planifications, les interventions et les approbations partagées. Il s'agit d'un guide, pas d'un conseil juridique.",
whatsAffectingScore: "Qu'est-ce qui affecte votre score",
scoreHint: "Chaque élément affiche les points appliqués avant que le score ne soit plafonné entre 0 et 100.",
noScoredAdjustments: "Aucun ajustement noté — le score est à la valeur de référence (100 avant écrêtage).",
findingsInLatestReport: "Constats du dernier rapport",
openFindingA11y: "Ouvrir le constat : {{label}}",
positiveSignals: "Signaux positifs",
recommendedActions: "Actions recommandées",
noActionsLine: "Aucune action spécifique — continuez à surveiller les planifications et les documents.",
automateTitle: "Créer automatiquement un travail de renouvellement",
automateBody: "Lorsqu'un certificat ou un document approche de l'expiration, créer l'intervention de renouvellement et prévenir la bonne personne.",
goTo: "Aller à",
quickLinkDocuments: "Documents",
quickLinkInspections: "Inspections",
quickLinkJobs: "Interventions",
done: "Terminé",
},
videoCapture: {
permissionRequiredTitle: "Autorisation requise",
permissionMessage: "Veuillez autoriser l'accès à {{type}} pour continuer.",
cameraAccessType: "l'appareil photo",
photoLibraryAccessType: "la photothèque",
videoTooLongTitle: "Vidéo trop longue",
videoTooLongBody: "Les vidéos doivent durer {{max}} secondes ou moins. Cette vidéo dure {{actual}} secondes.",
couldNotAddVideoTitle: "Impossible d'ajouter la vidéo",
failedToAddVideo: "Échec de l'ajout de la vidéo. Vérifiez votre connexion et réessayez.",
addVideoTitle: "Ajouter une vidéo",
chooseAnOption: "Choisissez une option",
recordVideo: "Enregistrer une vidéo",
chooseFromLibrary: "Choisissez dans la bibliothèque",
videoLimitReachedTitle: "Limite vidéo atteinte",
videoLimitReachedBody_one: "Vous pouvez joindre jusqu’à {{count}} vidéo ici. Supprimez-en une pour en ajouter une autre.",
videoLimitReachedBody_other: "Vous pouvez joindre jusqu’à {{count}} vidéos ici. Supprimez-en une pour en ajouter une autre.",
removeVideoTitle: "Supprimer la vidéo",
removeVideoBody: "Êtes-vous sûr de vouloir supprimer cette vidéo ?",
playVideoA11y: "Lire la vidéo {{index}}",
videoPreviewA11y: "Aperçu de la vidéo {{index}}",
videoLabel: "Vidéo {{index}}",
removeVideoA11y: "Supprimer la vidéo {{index}}",
addVideoLabel: "Ajouter une vidéo",
videoLimitReachedBody_many: "Vous pouvez joindre jusqu’à {{count}} vidéos ici. Supprimez-en une pour en ajouter une autre.",
},
signatureCaptureModal: {
defaultHelperText: "Signez avec votre doigt ou votre souris, puis appuyez sur Terminé.",
cancelSigningA11y: "Annuler la signature",
saveSignatureA11y: "Enregistrer la signature",
done: "Terminé",
},
conversationThread: {
defaultEmptyHint: "Aucun message pour l'instant. Démarrez la conversation.",
updates: "Mises à jour",
updatesWithName: "Mises à jour avec {{name}}",
earlier: "Plus anciens",
earlierA11y: "100 messages antérieurs",
newer: "Plus récents",
newerA11y: "100 messages plus récents",
latest: "Derniers",
latestA11y: "Derniers messages",
loadingMessages: "Chargement des messages…",
messagesUnavailable: "Les messages ne sont pas disponibles pour le moment.",
noMessagesInThisPart: "Aucun message dans cette partie de la conversation.",
startAnUpdatePlaceholder: "Rédigez une mise à jour…",
messageA11y: "Message",
sendMessageA11y: "Envoyer un message",
couldNotSendMessage: "Impossible d'envoyer le message.",
failedToSend: "Échec de l'envoi",
},
guideArticle: {
userGuideTitle: "Guide utilisateur",
helpTitle: "Aide",
articleNotFound: "Article non trouvé",
whyItMatters: "Pourquoi c'est important",
showMe: "Montrez-moi",
howToDoIt: "Comment faire",
whatToDoNext: "Que faire ensuite",
},
webQuickCreateMenu: {
quickCreateA11y: "Création rapide",
quickCreate: "Création rapide",
},
ownershipTransfer: {
aTeamMemberFallback: "un membre de l'équipe",
couldNotUpdateTitle: "Impossible de mettre à jour le transfert",
tryAgain: "Veuillez réessayer.",
doneTitle: "Terminé",
offerLapsesSuffix: " L'offre expire le {{date}}.",
offeredOwnershipTitle: "On vous a proposé de devenir propriétaire de {{teamName}}.",
offeredOwnershipBody: "{{initiatorName}} souhaite vous confier l'équipe. En tant que propriétaire, vous gérez les membres, la facturation et les paramètres de l'espace de travail ; {{initiatorName2}} devient administrateur.",
acceptOwnership: "Accepter la propriété",
nowOwnTeam: "Vous possédez désormais {{teamName}}.",
decline: "Refuser",
declinedOffer: "Vous avez décliné l'offre.",
waitingForAcceptTitle: "En attente que {{targetName}} accepte la propriété",
waitingForAcceptBody: "Rien ne change jusqu'à ce qu'ils acceptent. Pendant ce temps, vous restez propriétaire.",
cancelOffer: "Annuler l'offre",
offerWithdrawn: "L'offre a été retirée.",
},
routeError: {
title: "Cet écran a rencontré un problème",
body: "Le reste de l'application est toujours en cours d'exécution et votre travail hors ligne en file d'attente est sécurisé. Réessayez ou revenez en arrière et rouvrez cet écran.",
referenceLabel: "Référence : {{referenceId}}",
tryAgain: "Réessayer",
goBack: "Retour",
},
photoAttachButton: {
couldNotAddPhotoTitle: "Impossible d'ajouter une photo",
pleaseTryAgain: "Veuillez réessayer.",
permissionRequiredTitle: "Autorisation requise",
permissionMessage: "Veuillez autoriser l'accès à {{type}} pour continuer.",
cameraAccessType: "l'appareil photo",
photoLibraryAccessType: "la photothèque",
addPhotoTitle: "Ajouter une photo",
addPhotoBody: "Ajoutez la photo telle quelle ou dessinez d'abord pour mettre en évidence les zones.",
addNow: "Ajouter maintenant",
photoAdded: "Photo ajoutée",
drawToHighlight: "Dessiner pour mettre en évidence",
addPhotoOptionsTitle: "Ajouter une photo",
chooseAnOption: "Choisissez une option",
camera: "Appareil photo",
photoLibrary: "Photothèque",
attachPhotoA11y: "Joindre une photo",
},
qrResolver: {
lookupTimedOut: "La recherche du code QR a expiré.",
resolvingQrCode: "Résolution du code QR...",
scannedAssetTitle: "Vous avez numérisé un actif",
scannedAssetBody: "Ce code appartient à un bien géré dans AssetWRX. Choisissez ce que vous aimeriez faire.",
scannedAssetBodySignInOnly: "Ce code appartient à un bien géré dans AssetWRX. Connectez-vous pour le voir.",
reportAnIssue: "Signaler un problème",
reportAnIssueA11y: "Signaler un problème sur cet actif – aucun compte requis",
signInToView: "Connectez-vous pour voir",
signInToViewA11y: "Se connecter pour voir cet actif",
},
teamSwitcher: {
teamFallback: "Équipe",
personal: "Personnel",
switchTeam: "Changer d'équipe",
cancel: "Annuler",
},
requiredSkillsPicker: {
defaultLabel: "Compétences requises",
couldNotLoad: "Impossible de charger les compétences pour le moment.",
couldNotRefresh: "Impossible d'actualiser les compétences. Essayer à nouveau.",
requiredTitle: "Compétences requises",
skillsTitle: "Compétences",
requiredHint: "Sélectionnez une ou plusieurs compétences. Il en faut au moins une.",
optionalHint: "Sélectionnez une ou plusieurs compétences dans votre catalogue (facultatif).",
mustHaveTag: " · indispensable",
removeSkillA11y: "Retirer {{name}}",
changeRequiredSkills: "Modifier les compétences requises",
selectAtLeastOne: "Sélectionnez au moins une compétence requise",
addSkillsOptional: "Ajouter des compétences (facultatif)",
mandatoryHint: "Marquez une compétence « Indispensable » et toute personne ne possédant pas cette compétence ne se verra pas proposer ce travail. Les autres se classent simplement plus haut.",
searchSkillsA11y: "Rechercher des compétences",
searchSkillsPlaceholder: "Rechercher des compétences...",
loadingSkills: "Chargement des compétences...",
noSkillsFound: "Aucune compétence trouvée pour l'instant. Ajoutez des compétences dans les paramètres des prestataires.",
noSkillsMatch: "Aucune compétence ne correspond à votre recherche.",
removeSkillRowA11y: "Retirer {{name}}",
addSkillRowA11y: "Ajouter {{name}}",
mustHaveOnA11y: "{{name}} est un incontournable. Faites-en plutôt une préférence.",
mustHaveOffA11y: "Rendre {{name}} indispensable pour ce travail",
mustHave: "Indispensable",
done: "Terminé",
},
reportingPage: {
executiveSummary: "Résumé",
supportingDetail: "Détails complémentaires",
whatChanged: "Ce qui a changé",
whyItMatters: "Pourquoi c'est important",
action: "Action",
hideReportStatements: "Masquer les énoncés du rapport",
showReportStatements: "Afficher les énoncés du rapport et les lignes associées",
sourceLabel: "les enregistrements de ce rapport",
},
refineSheet: {
defaultTitle: "Affiner",
activeFilters_one: "{{count}} filtre actif",
activeFilters_other: "{{count}} filtres actifs",
noActiveFilters: "Aucun filtre actif",
reset: "Réinitialiser",
doneA11y: "Terminé",
done: "Terminé",
activeFilters_many: "{{count}} filtres actifs",
},
qrCodeDisplay: {
noQrCode: "Aucun code QR disponible",
copyErrorTitle: "Erreur",
copyErrorBody: "Échec de la copie du lien du code QR.",
shareMessageWithName: "QR Code pour {{name}} : {{url}}",
shareMessageNoName: "Code QR de l'actif : {{url}}",
copied: "Copié",
copyLink: "Copier le lien",
share: "Partager",
},
jobCard: {
urgencyLow: "Faible",
urgencyMedium: "Moyenne",
urgencyHigh: "Élevée",
urgencyCritical: "Critique",
scheduledFallback: "Planifié",
dueDate: "Échéance le {{date}}",
createdToday: "Créé aujourd'hui",
createdDate: "Créé {{date}}",
rejectedFallback: "Refusée",
rejectedWithReason: "Refusée : {{reason}}",
unassigned: "Non assigné",
newUpdate: "Nouvelle mise à jour",
updatedAt: "Mis à jour {{when}}",
skillCount_one: "{{count}} compétence",
skillCount_other: "{{count}} compétences",
a11yJob: "Intervention : {{title}}",
a11yAsset: "Actif : {{name}}",
a11yStatus: "Statut : {{status}}",
a11yPriority: "Priorité : {{priority}}",
a11yCategory: "Catégorie : {{category}}",
a11yAssignee: "Responsable : {{name}}",
a11ySchedule: "Planification : {{when}}",
a11yActivity: "Activité : {{activity}}",
a11yAttentionOverdue: "Attention : En retard",
a11yAttentionUnscheduled: "Attention : non programmé",
openAssetA11y: "Ouvrir l'actif {{name}}",
detailsFallback: "détails",
noAsset: "Aucun actif",
followOnPending: "Suivi en attente",
overdue: "En retard",
unscheduled: "Non planifié",
followOnPendingApproval: "Suivi · En attente d'approbation",
priorityColumnHint: "Priorité",
assigneeColumnHint: "Assigné à",
dueScheduleColumnHint: "Échéance / planification",
typeColumnHint: "Type",
skillCount_many: "{{count}} compétences",
},
healthCard: {
assetHealth: "Santé de l'actif",
noInspectionsYet: "Aucune inspection pour l'instant",
viewOpenJobsInWork: "Afficher les interventions ouvertes dans Travail",
startInspectionInWork: "Démarrer une inspection dans Travail",
viewHealthBreakdown: "Afficher la répartition de l'état de santé",
lastInspected: "Dernière inspection {{date}}",
},
failedSyncRecovery: {
defaultTitle: "Impossible de synchroniser",
dismiss: "Ignorer",
copyError: "Copier l'erreur",
retrySync: "Réessayer la synchronisation",
},
conflictResolution: {
title: "Quelqu’un d’autre a modifié cette inspection",
body: "Quelqu’un a enregistré cette inspection pendant que certaines de vos réponses attendaient d’être enregistrées. Vos réponses restent sur cet appareil jusqu’à votre choix.",
mergeAndSync: "Garder mes réponses",
useLatestFromServer: "Utiliser les leurs",
hint: "Utiliser les leurs supprime de cet appareil vos réponses non enregistrées.",
decideLater: "Décider plus tard",
},
evidenceCapture: {
defaultDocumentSectionLabel: "Documents",
media: "Médias",
addPhotoOrVideoA11y: "Ajouter une photo ou une vidéo",
addPhotoA11y: "Ajouter une photo",
addVideoA11y: "Ajouter une vidéo",
noMediaAttached: "Aucun média joint",
hintPhoto_one: "Jusqu'à {{count}} photo",
hintPhoto_other: "Jusqu'à {{count}} photos",
hintVideoWithPrefix_one: "Jusqu'à {{count}} vidéo",
hintVideoWithPrefix_other: "Jusqu'à {{count}} vidéos",
hintVideoNoPrefix_one: "{{count}} vidéo",
hintVideoNoPrefix_other: "{{count}} vidéos",
hintVideoDurationSuffix: ", {{seconds}} s maximum",
addEvidence: "Ajouter une preuve",
takeAPhoto: "Prendre une photo",
chooseAPhoto: "Choisissez une photo",
recordAVideo: "Enregistrer une vidéo",
chooseAVideo: "Choisir une vidéo",
hintPhoto_many: "Jusqu'à {{count}} photos",
hintVideoWithPrefix_many: "Jusqu'à {{count}} vidéos",
hintVideoNoPrefix_many: "{{count}} vidéos",
},
localComplianceRead: {
clearRead: "Effacer la lecture",
checkThis: "Vérifier ceci",
confirm: "Confirmer",
certificateNumber: "Numéro de certificat",
nextDue: "Prochaine échéance",
result: "Résultat",
readingOnDevice: "Lecture du document sur cet appareil…",
useCertificateNumber: "Utiliser le numéro de certificat {{value}}",
useNextDueDate: "Utiliser la prochaine date d'échéance {{value}}",
title: "Lire ce document",
dismissA11y: "Ignorer la lecture du document",
readOnDeviceNoCredits: "Lire sur cet appareil — aucun crédit IA utilisé.",
use: "Utiliser",
},
planPicker: {
trial: "Essai gratuit de {{days}} jours, puis {{price}}",
adds: "Ajoute {{list}}",
  titleLimit: "Passez à un forfait supérieur pour en ajouter",
  titleChange: "Choisissez votre forfait",
  titleUnlock: "Débloquer {{feature}}",
  checkoutFailedTitle: "Impossible de lancer le paiement",
  introLimit: "Choisissez un forfait pour ajouter des actifs et débloquer plus de fonctionnalités. La période gratuite restante est conservée.",
  introChange: "Votre forfait définit les fonctionnalités disponibles. Les actifs et les crédits IA sont facturés séparément.",
  loading: "Chargement des forfaits…",
  unavailable: "Impossible de charger les forfaits. Réessayez plus tard.",
  notNow: "Pas maintenant",
  current: "Actuel",
yourPlan: "Votre forfait",
payFor: "Payer {{name}}",
renew: "Renouveler {{name}}",
  priceFree: "Gratuit",
  priceTalkToUs: "Contactez-nous",
  priceFromPerAsset: "Dès {{price}}/actif/mois",
  priceFeePlusAssets: "{{price}}/mois + par actif",
  priceFeeOnly: "{{price}}/mois",
  priceAnnualPlusAssets: "{{price}}/an + par actif",
  priceAnnualOnly: "{{price}}/an",
  continueWith: "Continuer avec {{name}}",
  contactSales: "Contacter les ventes",
  managedOnWeb: "Non disponible à l'achat dans l'application",
  otherPlans: "Autres forfaits",
  webOnly: "Les forfaits et les crédits se choisissent dans Facturation et utilisation.",
},
storePlans: {
  title: "S’abonner dans l’app",
  loading: "Chargement des forfaits…",
  unavailable: "Les abonnements ne sont pas disponibles pour le moment. Réessayez plus tard.",
  perMonth: "{{price}} par mois",
  perYear: "{{price}} par an",
  subscribe: "S’abonner",
  working: "En cours…",
  restore: "Restaurer les achats",
  activating: "Activation de votre forfait…",
  pending: "Votre achat a abouti. Votre forfait sera mis à jour dans un instant. Touchez Actualiser dans Facturation et utilisation.",
  manage: "Gérer l’abonnement",
  billedElsewhere: "L’abonnement de cet espace de travail est facturé en dehors de cette app.",
  termsIos: "Le paiement est débité de votre identifiant Apple à la confirmation. L’abonnement se renouvelle automatiquement sauf résiliation au moins 24 heures avant la fin de la période en cours. Gérez-le ou résiliez-le dans les réglages de votre compte App Store.",
  termsAndroid: "Le paiement est débité de votre compte Google à la confirmation. L’abonnement se renouvelle automatiquement sauf résiliation avant la fin de la période en cours. Gérez-le ou résiliez-le dans les abonnements Google Play.",
  termsOfUse: "Conditions d’utilisation",
  privacyPolicy: "Politique de confidentialité",
},
planLimit: {
subscriptionRequiredTitle: "Limite du forfait atteinte",
nextAssetNeedsPlan: "Vous avez utilisé les actifs gratuits de votre forfait. Le suivant nécessite un forfait payant.",
assetsUsed: "{{used}} actifs sur {{limit}} de votre forfait.",
checkoutUnavailableTitle: "L’achat n’est pas encore disponible ici",
checkoutUnavailableBody: "Les forfaits ne peuvent pas être achetés depuis cette version. Contactez-nous et nous le mettrons en place pour vous.",
memberBodyCreate: "Votre espace de travail a atteint la limite d'actifs de son forfait. Un administrateur de l'espace de travail doit choisir un forfait avant de pouvoir ajouter un autre actif en service.",
memberBodyImport: "Votre espace de travail a atteint la limite d'actifs de son forfait. Un administrateur doit choisir un forfait avant que d'autres actifs puissent être importés.",
  title: "Limite du forfait atteinte",
  notNow: "Pas maintenant",
  seePlans: "Voir les forfaits",
  perAsset: "Par actif",
  limit: "Limite d’actifs : {{count}}",
},
/** Field sync states (lib/fieldSync/contract.ts is the English contract; a test keeps en-US equal to it). */
fieldSync: {
local_draft: {
label: "Enregistré localement",
message: "Enregistré sur cet appareil — la synchronisation se fera automatiquement dès le retour en ligne.",
},
pending_sync: {
label: "Synchronisation",
message: "Synchronisation de vos modifications…",
},
synced: {
label: "Synchronisé",
message: "Toutes les modifications sont synchronisées.",
},
failed_sync: {
label: "Nécessite une attention",
message: "Impossible d'enregistrer cette modification — votre travail est en sécurité sur cet appareil. Touchez pour réessayer.",
messageWithDetail: "Échec de l'enregistrement : {{detail}} Touchez pour réessayer.",
},
conflict_review: {
label: "Nécessite une attention",
message: "Quelqu'un d'autre a mis ceci à jour — jetez un œil avant d'enregistrer.",
},
online_required: {
label: "Connexion requise",
message: "Reconnectez-vous pour terminer cette action. Les informations saisies resteront ici.",
},
},
editionPlanSection: {
contactSalesTitle: "Contacter le service commercial",
contactSalesBody: "Envoyez un e-mail à {{email}} pour discuter du forfait {{plan}}.",
notSet: "Non défini",
customPricing: "Tarification personnalisée",
noCharge: "Sans frais",
changePlan: "Changer de forfait",
chooseAPlan: "Choisissez un forfait",
changeTitle: "Passer à {{name}} ?",
changeBody: "Un forfait supérieur commence maintenant, et la différence pour le reste de cette période de facturation est facturée aujourd’hui. Un forfait inférieur, ou Free, commence à votre date de renouvellement ; d’ici là, rien ne change.",
scheduledTitle: "Changement de forfait programmé",
scheduledBody: "Votre forfait passe à {{name}} le {{date}}. D’ici là, vous gardez ce que vous avez. Choisissez à nouveau votre forfait actuel pour annuler le changement.",
changeConfirm: "Changer",
changeCancel: "Pas maintenant",
billMonthly: "Mensuel",
billYearly: "Annuel",
billingTerm: "Facturation",
},
legalDoc: {
unknownDocument: "Document inconnu.",
loadFailed: "Ce document n'a pas pu être chargé. Veuillez réessayer sous peu.",
versionLabel: "Version {{version}}",
effectiveLabel: "En vigueur {{date}}",
titleFallback: "Mentions légales",
loading: "Chargement…",
errorTitle: "Erreur",
documentNotFound: "Document introuvable.",
},
notificationRecovery: {
title: "Notification",
safeRecovery: "Récupération sécurisée",
},
actionSheet: {
cancelA11y: "Annuler",
cancel: "Annuler",
},
actionPopover: {
closeCreateMenuA11y: "Fermer le menu de création",
},
fieldModeToggle: {
fieldModeA11y: "Mode terrain",
fieldModeHint: "Augmente le contraste et les cibles tactiles pour une utilisation en extérieur",
fieldMode: "Mode terrain",
},
appErrorBoundary: {
title: "Une erreur s'est produite",
body: "AssetWRX a détecté l'erreur. Vous pouvez réessayer cet écran sans perdre le travail hors ligne en attente.",
retry: "Réessayer",
},
profileAvatar: {
profileAvatarA11y: "Avatar du profil",
profileInitialsA11y: "Initiales du profil",
},
nativeDateTimePicker: {
selectDate: "Choisir une date",
selectTime: "Sélectionnez l'heure",
cancelSelectionA11y: "Annuler la sélection {{mode}}",
cancel: "Annuler",
confirmA11y: "Confirmer {{mode}}",
done: "Terminé",
},
assetMapView: {
basemapStreets: "Rues",
basemapSatellite: "Satellite",
basemapTopographic: "Topographique",
overlayClusters: "Regroupement des points",
overlayHeatmap: "Carte thermique de densité",
overlaySelectionHighlight: "Surbrillance de la sélection",
threeDCameraTilt: "Inclinaison de la caméra 3D",
threeDTerrainRelief: "Relief du terrain 3D",
hideMapOptionsA11y: "Masquer les options de la carte",
basemapA11y: "Fond de carte : {{name}}",
mapOptionsA11y: "Options de la carte",
rendererUnavailable: "L'affichage de la carte n'est pas disponible sur cet appareil.",
},
uiCopy: {
  checkAnswerNotSavedTitle: "Impossible d’enregistrer cette réponse",
  checkLoadFailed: "Impossible de charger cette vérification.",
  fieldAssist: {
    tryAgain: "Veuillez réessayer.",
    revert: "Rétablir",
    discard: "Abandonner",
    accept: "Accepter",
    suggestedTitle: "Texte suggéré",
    dictate: "Dicter",
    stop: "Arrêter",
  },
markAllNotificationsAsRead_2777a0: "Marquer toutes les notifications comme lues",
retrySearch_eed38a: "Réessayer la recherche",
importAssetsFromSpreadsheet_319028: "Importer des actifs à partir d'une feuille de calcul",
filterBySite_cf1cee: "Filtrer par site",
couldntLoadYourAssets_9878ab: "Impossible de charger vos actifs",
yourAssetsAreStillThereCheckYour_f01439: "Vos actifs sont toujours là. Vérifiez votre connexion et réessayez.",
loadingRelationshipView_b7eaea: "Chargement de la vue des relations…",
noMappedAssetsYet_6f573a: "Aucun actif mappé pour l’instant.",
saveCoordinatesOnAnAssetToEnable_da096f: "Enregistrez des coordonnées sur un actif pour activer la vue cartographique.",
mapUnavailableRightNow_d6091e: "Carte indisponible pour le moment.",
theAssetListStillWorksNormally_b8aeb7: "La liste des actifs fonctionne toujours normalement.",
loadingMap_8f267a: "Chargement de la carte…",
assignSite_e1d79b: "Attribuer un site",
assignToSite_5f6e86: "Attribuer au site",
contactInsight_51a9e3: "Aperçu des contacts",
findContactsSkills_f8dc04: "Rechercher des contacts",
refineContactFilters_fa9072: "Affiner les filtres de contact",
importContactsFromAFileOrYour_210d87: "Importer des contacts à partir d'un fichier ou de votre appareil",
refineContacts_982f6f: "Affiner les contacts",
opensFiltersToChangeWhichContactsAre_304ff8: "Ouvre des filtres pour modifier les contacts affichés.",
chooseAContactToSeeSharedAssets_8202a6: "Choisissez un contact pour voir les actifs partagés, les demandes et le travail associé sans quitter cette page.",
noContactDetailsOnFile_131e9d: "Aucune coordonnée dans le dossier",
noLinkedSkills_16d322: "Aucune compétence liée",
noOpenJobsForThisContact_4857c4: "Aucune intervention ouverte pour ce contact",
historyNotes_83ccc2: "Historique et notes",
couldntRefreshYourWorkShowingWhatWas_8e2372: "Impossible d'actualiser votre travail — affichage des dernières données chargées. Touchez pour réessayer.",
generateAdvancedReport_7e5def: "Générer un rapport avancé",
buildsAFullReportUsingInspectionsJobs_bfa133: "Crée un rapport complet à l'aide d'inspections, d'interventions, de documents, de données sur les risques, d'un historique de maintenance et d'une recherche Internet facultative.",
advancedReportInsight_a02085: "Aperçu du rapport avancé",
noAdvancedReportGeneratedYet_59d1d4: "Aucun rapport avancé n'a encore été généré.",
fillInDetailsToSeeAPreview_84bd8b: "Remplissez les détails pour voir un aperçu ici.",
assetNameRequired_06d7dc: "Nom de l'actif (obligatoire)",
suggestedIdentity_36046f: "Identité suggérée",
dismissIdentitySuggestion_f3e055: "Ignorer la suggestion d'identité",
identifyTheAssetTypeFromThePhoto_d205fa: "Identifiez le type d'actif à partir de la photo à l'aide de l'IA",
identifiedFromPhoto_c90812: "Identifié à partir de la photo",
applyTheIdentifiedAssetType_a066ab: "Appliquer le type d'actif identifié",
applyType_00972d: "Appliquer le type",
dismissPhotoIdentity_a1052e: "Ignorer l'identification par photo",
inServiceToday_7a4392: "En service aujourd’hui ?",
yesInUse_0e9408: "Oui, en cours d'utilisation",
notYet_8de95f: "Pas encore",
qRCodeWillBeLinkedAfterCreation_87a9e9: "Le code QR sera lié après la création",
matchMyNearestSite_4d4d97: "Utiliser mon site le plus proche",
tapToAddYourFirstPhoto_7f8b7c: "Appuyez pour ajouter votre première photo",
gallery_9c30a3: "Galerie",
removeAllPhotos_6c3c73: "Supprimer toutes les photos",
iDSerialOptional_25584f: "ID / N° de série (facultatif)",
thisReferenceLinksIoTDevicesAndAPI_4f5ce4: "Cette référence relie les appareils IoT et les événements API à cet actif.",
scanIDOrSerial_956e65: "Scanner l'ID ou le numéro de série",
readFromPhoto_ee811f: "Lire depuis une photo",
relationshipsOptional_df493d: "Relations (facultatif)",
vehicleType_964438: "Type de véhicule",
fuelType_0e58d4: "Type de carburant",
usage_0bb186: "Utilisation",
propertyType_8ad7ea: "Type de bien",
occupancy_570235: "Occupation",
equipmentType_d92829: "Type d'équipement",
powerSource_56547a: "Source d'énergie",
installation_c81b79: "Installation",
whereIsThisAssetInItsLife_ffff43: "Où en est cet actif dans son cycle de vie ?",
criticalityOptional_491f40: "Criticité (facultatif)",
howCriticalIsThisAssetToOperations_04df20: "Dans quelle mesure cet actif est-il essentiel aux opérations ?",
operatingContextOptional_178f94: "Contexte d'exploitation (facultatif)",
complianceTagsOptional_2df1fc: "Étiquettes de conformité (facultatif)",
identifyAndTag_f946d5: "Identifier et étiqueter",
addMoreNowOrAnytimeLater_3eac61: "Ajoutez-en davantage maintenant ou à tout moment ultérieurement.",
potentialDuplicatesDetected_4b9918: "Doublons potentiels détectés",
moreOptions_0a1b2c: "Plus d’options",
reviewMatchingAssetsBeforeCreatingANew_90559b: "Vérifiez les actifs correspondants avant de créer un nouvel enregistrement.",
useExistingAsset_3f06d4: "Utiliser l'actif existant",
openExisting_941fb8: "Ouvrir existant",
continueAnyway_011856: "Continuer quand même",
createLinkPossibleDuplicate_e5dcab: "Créer et lier comme doublon possible",
markIntentionallyDistinct_cc3540: "Marquer comme intentionnellement distinct",
subtype_a729bb: "Type de document précis",
loadingAsset_a104a6: "Chargement de l'élément",
retryLoadingAsset_544af8: "Réessayez de charger l'élément",
onlyTheAssetsOwnerOrItsTeam_95113f: "Seul le propriétaire de l'actif ou son équipe peut le modifier. Vous pouvez toujours le consulter et créer du travail pour cet actif.",
basicDetails_42450f: "Informations de base",
photosOptional_c0ea6e: "Photos (facultatif)",
removeAllPhotos_1329e0: "Supprimer toutes les photos",
egToyotaCamry2024_d36609: "par ex. Toyota Camry 2024",
locationNotes_259645: "Emplacement et notes",
addDetailsAboutThisAsset_ec093a: "Ajouter des détails sur cet actif...",
identifiers_649d28: "Identifiants",
importAssets_9158f1: "Importer des éléments",
invalidSharedAssetLink_1f7b4c: "Lien d'actif partagé non valide.",
sharedAsset_80c5e0: "Actif partagé",
checkingAccess_c5108c: "Vérification de l'accès…",
signInWithTheAccountThatWas_5dd47c: "Connectez-vous avec le compte qui a été invité en tant que contact pour accéder directement à cet actif partagé.",
signInToViewThisSharedAsset_c8d337: "Connectez-vous pour voir cet actif partagé",
createAnAccountToViewThisShared_bef153: "Créez un compte pour afficher cet actif partagé",
couldNotCheckAccess_c29580: "Impossible de vérifier l'accès",
accessNotAvailable_7c84ab: "Accès non disponible",
thisShareIsntLinkedToYourAccount_305fbe: "Ce partage n'est pas encore lié à votre compte ou le propriétaire a révoqué l'accès. Si vous venez d'accepter une invitation, actualisez pour réessayer.",
backToAssets_caff2b: "Retour aux actifs",
refreshAccess_822875: "Actualiser l'accès",
thisAssetIsNotSharedWithYour_76b685: "Cet actif n'est pas partagé avec votre contact lié, ou le partage a été créé pour une autre fiche de contact.",
shareDeclined_292608: "Partage refusé",
youPreviouslyDeclinedAccessToThisAsset_d9ccbb: "Vous avez précédemment refusé l'accès à cet élément.",
acceptSharedAsset_79b229: "Accepter l'actif partagé",
declineSharedAsset_6908ef: "Refuser l'actif partagé",
sharedBy_a5fe3b: "Partagé par",
youaposllBeAbleToView_bc03b3: "Vous pourrez voir",
acceptToViewThisAssetWithThe_8df15c: "Acceptez pour voir cet actif avec l'accès ci-dessus, ou refusez pour supprimer l'invitation.",
assetdetail_27a5fa: "asset-detail",
templateName_0a8669: "Nom de la check-list *",
templateNameRequired_5db301: "Nom de la check-list (obligatoire)",
selectOneOrMore_1489f2: "Sélectionnez un ou plusieurs",
updateChecklist_fce28f: "Mettre à jour la liste de contrôle",
editChecklist_8c20d6: "Modifier la liste de contrôle",
inspectionObjective_6129b6: "Objectif d’inspection *",
describeWhatYouWantToInspectEg_1fb338: "Décrivez ce que vous souhaitez inspecter (par exemple, vérification du véhicule avant l'achat, sécurité et état mécanique).",
egPrepurchaseVehicleCheckSafetyAndMechanical_871268: "p. ex. Contrôle avant achat d'un véhicule, sécurité et état mécanique",
inspectionObjective_ce4266: "Objectif de l'inspection",
categories_1c14ef: "Catégories *",
assetOptional_95db78: "Actif (facultatif)",
selectAnAsset_9dd87a: "Sélectionner un actif",
inspectionDepth_2b1225: "Profondeur d'inspection",
targetDurationMinutesOptional_fe3727: "Durée cible (minutes, facultatif)",
targetDurationInMinutes_1897b3: "Durée cible en minutes",
evidenceMode_e83c42: "Mode preuve",
optimizeForSpeed_56e47b: "Optimiser pour la vitesse",
optimizationFocusOptional_0ebfbe: "Objectif d'optimisation (facultatif)",
failonlyEvidenceFocusKeepsEvidenceModeOn_1f0e17: "Le mode « preuve uniquement en cas d'échec » conserve la capture de preuves limitée aux échecs.",
baseTemplateOptional_d80914: "Check-list de base (facultatif)",
preferToBuildItYourselfCreateManually_ae612e: "Vous préférez le créer vous-même ? Créer manuellement",
draftSetup_a9804f: "Configuration du brouillon",
guidance_b5e0b5: "Conseils",
useThisWorkspaceToIterateObjectiveDuration_76a28d: "Dites ce que vous inspectez et pourquoi. L’IA rédige la liste ; vous la vérifiez et la modifiez avant tout enregistrement.",
baseTemplate_54f2a3: "Check-list de base",
generatingTemplateDraft_8fdb48: "Génération d’un brouillon de check-list…",
thisMayTakeAMoment_2cd85b: "Cela peut prendre un moment.",
buyUsageCredits_a49d2e: "Acheter des crédits d'utilisation",
templateName_954ab9: "Nom de la check-list",
draftRationaleAndWarnings_0ce71c: "Justification et avertissements du brouillon",
groupsItems_9bcc66: "Groupes et éléments",
draftSummary_4e141c: "Résumé du brouillon",
warnings_1430f9: "Avertissements",
reviewDraft_6a9bff: "Révision du brouillon",
editThenSaveOrDiscard_f1ef70: "Modifier puis enregistrer ou annuler",
inspectionreport_04aa89: "inspection-report",
createARecurringJob_4a519d: "Créer un plan de maintenance",
newRecurringJob_dcc457: "Nouveau plan de maintenance",
couldntLoadRecurringJobs_cbd362: "Impossible de charger les plans de maintenance",
noRecurringJobsYet_c5a4c5: "Aucun plan de maintenance pour le moment",
openCurrentJob_cf8169: "Ouvrir l'intervention en cours",
end_a2bb9d: "Fin",
jobreport_c30f90: "job-report",
pleaseWaitFinalisingYourSubscription_9839a5: "Veuillez patienter — finalisation de votre abonnement.",
openPrivacyAmpData_453313: "Ouvrir la confidentialité et les données",
retryLoadingYourWorkspace_be5137: "Réessayez de charger votre espace de travail",
signInToViewThisQuoteRequest_317846: "Connectez-vous pour consulter cette demande de devis",
thisInviteWasSentToYourEmail_d77859: "Cette invitation a été envoyée à votre adresse e-mail. Connectez-vous – ou créez un compte gratuit avec cet e-mail – et la demande de devis s'ouvrira automatiquement.",
retryLoadingQuoteInvitation_7c3b72: "Réessayez de charger l'invitation au devis",
ifTheInviteWasSentToA_2463c0: "Si l'invitation a été envoyée à une autre adresse e-mail, connectez-vous avec cette adresse pour l'ouvrir.",
retryLoadingQuoteContext_2406e9: "Réessayez de charger le contexte du devis",
loadingQuoteDetailsAndSavedDraft_3c2a11: "Chargement des détails du devis et du brouillon enregistré",
requestDetails_bf5023: "Détails de la demande",
additionalContextFromClient_1d46de: "Contexte supplémentaire (du client)",
yourQuote_756213: "Votre devis *",
yourQuoteRequired_afd50e: "Votre devis (obligatoire)",
durationEstimateOptional_ace4e9: "Estimation de la durée (facultatif)",
availabilityWindowOptional_9e64b7: "Créneau de disponibilité (facultatif)",
materialsIncluded_5ffbdc: "Matériel inclus",
materialsDetails_72ea3e: "Détails des matériaux",
details_4dade5: "Détails...",
warrantyOptional_010797: "Garantie (facultatif)",
eg12Months_0ff628: "par ex. 12 mois",
additionalDetails_04831c: "Détails supplémentaires...",
attachmentsOptional_106896: "Pièces jointes (facultatif)",
loadingInspection_1ad221: "Chargement de l'inspection…",
whatTheInspectionFound_b53913: "Ce que l'inspection a révélé",
avgCondition_6b3737: "État moyen",
needsDecision_229276: "Nécessite une décision",
inspectorNotes_2f7e20: "Notes de l'inspecteur",
recommendedRepair_a70281: "Réparation recommandée",
labourMaterials_08ee77: "Main-d'œuvre et matériaux",
estimatedCost_35caa4: "Coût estimé",
jobsFromThisReport_fa5fee: "Interventions de ce rapport",
tapAJobToSeeFullDetails_fe7c8c: "Appuyez sur une intervention pour voir tous les détails et le statut.",
couldNotSyncReview_375861: "Impossible de synchroniser l'examen",
inspectionreview_077ff2: "inspection-review",
acceptTeamInvitation_2f956c: "Accepter l'invitation de l'équipe",
acceptInvitation_f41d2a: "Accepter l'invitation",
declineTeamInvitationForNow_7ce799: "Refuser l’invitation à l’équipe pour l’instant",
yourTeams_d63712: " Vos équipes",
createNewTeam_a8d9ef: "Créer une nouvelle équipe",
addTeam_046c3a: "Ajouter une équipe",
noTeam_178b88: "Aucune équipe",
createATeamToCollaborateInviteContractors_bf3947: "Créez une équipe pour collaborer, inviter des entrepreneurs et attribuer des interventions.",
createTeam_8d826c: "Créer une équipe",
createTeam_8b8973: "Créer une équipe",
giveYourTeamAName_0161ea: "Donnez un nom à votre équipe",
teamName_9b11ed: "Nom de l'équipe",
egAcmeInspections_60df82: "par ex. Inspections Acme",
newTeam_7ff544: "Nouvelle équipe",
searchMembers_bdad23: "Rechercher des membres…",
searchMembers_a1d97a: "Rechercher des membres",
usedToMatchWorkToPeopleA_4d8242: "Sert à attribuer le travail aux bonnes personnes. Une intervention peut marquer une compétence comme « indispensable » : toute personne qui ne la possède pas ne sera pas proposée pour cette intervention.",
makeOwner_f99257: "Définir comme propriétaire",
resetTwofactor_4efb84: "Réinitialiser la double authentification",
removeMember_1c31d1: "Supprimer un membre",
closeMenu_6c9fc9: "Fermer le menu",
invitations_4b0b9f: " Invitations",
workspaceMembershipGrantsAppAccessContactRecords_e5c34b: "L'adhésion à l'espace de travail donne accès à l'application. Les fiches de contact restent distinctes et peuvent être liées au travail sans devenir membres.",
inviteANewTeamMember_52559c: "Inviter un nouveau membre de l'équipe",
invitePeople_e1eb97: "Inviter des personnes",
emailAddressesForInvitationsOnePerLine_5e7e7e: "Adresses e-mail pour les invitations, une par ligne",
addOneOrMoreAddressesSeparatedBy_162bd6: "Ajoutez une ou plusieurs adresses, séparées par une nouvelle ligne ou une virgule.",
whatShouldTheyBeAbleToDo_224294: "Que devraient-ils pouvoir faire ?",
cancelInviteForm_156d89: "Annuler le formulaire d'invitation",
noPendingInvitations_8d0735: "Aucune invitation en attente",
showMeHowToInviteAMember_6b43bc: "Montrez-moi comment inviter un membre",
showMeHowToInviteSomeone_61b6a4: "Montrez-moi comment inviter quelqu'un",
teamSettings_373140: " Paramètres de l'équipe",
workspaceDefaultsAccount_4ae7a6: "Paramètres par défaut de l'espace de travail (compte)",
baselineDefaultsForTheWorkspaceYouCan_f78072: "Valeurs par défaut pour l'espace de travail. Vous pouvez aussi les définir dans Compte → Paramètres si vous ne faites pas partie d'une équipe.",
workspaceCommunication_2c579b: "Communication de l'espace de travail",
teamOverrides_4c6f5e: "Paramètres propres à l'équipe",
overrideThisTeamOrKeepItInheriting_1d3b9a: "Personnalisez les paramètres de cette équipe, ou laissez-la hériter des valeurs par défaut de l'espace de travail.",
teamCurrencyMode_f9eea7: "Mode devise de l'équipe",
inheritWorkspace_879a54: "Hériter de l'espace de travail",
override_842192: "Personnaliser",
teamCommunicationMode_d0ba75: "Mode de communication de l'équipe",
effectiveDefaultsInThisContext_3905f8: "Valeurs par défaut effectives dans ce contexte",
onlyWorkspaceOwnersAndAdminsCanChange_325bf7: "Seuls les propriétaires et administrateurs d’espace de travail peuvent modifier ces valeurs par défaut.",
openWorkspaceAIAndAutomationAudit_f2fd0f: "Ouvrir l'audit IA et automatisation de l'espace de travail",
workspaceAIAutomationAudit_79db57: "Audit IA et automatisation de l'espace de travail",
renameTeam_bbd28e: "Renommer l'équipe",
leaveTeam_b445f9: "Quitter l'équipe",
transferOwnership_a6819e: "Transférer la propriété",
deleteTeam_a9661e: "Supprimer l'équipe",
chooseAMemberToOfferOwnershipTo_ee74d9: "Choisissez un membre à qui proposer la propriété. Il doit accepter ; vous devenez alors administrateur.",
input_b568d4: "Entrée",
plainlanguageGuideForThisTrigger_546a3a: "Guide en langage simple pour ce déclencheur",
whatYouCanPassToAnotherSystem_3385b2: "Ce que vous pouvez transmettre à un autre système",
sendingDataOutTypicalWebhookStep_9fa855: "Envoi de données (étape de webhook typique)",
fixedPartReplaceTheExampleWebAddress_b73594: "Partie fixe — remplacez l'exemple d'adresse Web par la vôtre",
automaticPartFilledFromThisTriggerWhen_a65fba: "Partie automatique — remplie à partir de ce déclencheur lors de l'exécution de la recette",
optionalFiltersAbove_b7c00b: "Filtres facultatifs (ci-dessus)",
trigger_56cc41: "trigger.",
trigger_082e86: "trigger.…",
advancedRecipeBuilder_799724: "Générateur de recettes avancé",
fullTriggerConditionAndStepControlFor_c176d8: "Contrôle complet du déclencheur, de la condition et des étapes pour les utilisateurs avancés. Préférez le mode guidé pour les nouvelles automatisations lorsqu'un modèle convient.",
triggerCatalog_b27d78: "Catalogue des déclencheurs",
actionCatalog_44816c: "Catalogue d'actions",
howToCreateARecipe_18bda4: "Comment créer une recette",
recipesConnectATriggerWhenToOne_9c1ff3: "Les recettes connectent un déclencheur (quand) à une ou plusieurs actions (quoi). Rien ne s'exécute en production tant que vous n'activez pas le brouillon depuis la liste de droite.",
recipeWizard_6830a5: "Assistant de recette",
buildADraftBelowThenActivateIt_219398: "Créez un brouillon ci-dessous, puis activez-le à partir de la liste des recettes.",
syncCompletedInspectionsToCRM_2594a7: "Synchroniser les inspections terminées avec CRM",
optionalInternalNote_dedb5c: "Note interne facultative",
triggerType_a8b3dc: "Type de déclencheur",
chooseWhenThisRecipeShouldRunOptions_065235: "Choisissez quand cette recette doit être exécutée. Les options sont regroupées par sujet ; le code court sous chaque nom est une référence facultative si vous mappez des champs d'un autre système.",
selectedTrigger_4573c4: "Déclencheur sélectionné",
intervalMinutes_617c3f: "Intervalle en minutes",
conditionsOptional_d2f0fb: "Conditions (facultatif)",
onlyRunWhenTheIncomingEventMatches_c87bd3: "S'exécute uniquement lorsque l'événement entrant correspond à chaque ligne que vous ajoutez. Utilisez des noms de champs courts de votre système source (par exemple, status ou id sur l'enregistrement). Laissez vide pour s'exécuter à chaque déclenchement.",
jSONPath_a8136f: "Chemin JSON",
dataobjectstatus_f2b5ba: "data.object.status",
value_8dce17: "Valeur",
completedOrOpenpaused_f935e5: "completed ou [\"open\",\"paused\"]",
addCondition_42fe69: "Ajouter une condition",
noFiltersEveryMatchingTriggerRunsThe_5cdf5e: "Aucun filtre — chaque déclencheur correspondant exécute les actions.",
actionsRunInOrder_dd55c2: "Actions (exécutées dans l'ordre)",
pickWhatEachStepShouldDoThen_8b8ac5: "Choisissez ce que chaque étape doit faire, puis collez ou modifiez le JSON. Utilisez la case grise sous votre déclencheur pour obtenir des exemples prêts à être copiés et renommez les champs pour qu'ils correspondent à vos autres logiciels.",
actionType_fece43: "Type d'action",
fixedValuesJSON_3002d2: "Valeurs fixes (JSON)",
valuesFromTheEventJSON_11f1b5: "Valeurs de l'événement (JSON)",
urltriggerdatawebhookcallbackUrl_24747a: "{\"url\": \"trigger.data.webhook.callbackUrl\"}",
addAction_2824f0: "Ajouter une action",
stableKeysScopesSchemasSamplesAndConnector_a9453b: "Clés stables, portées, schémas, exemples et indications de connecteur pour les développeurs externes.",
zapier_569964: "Zapier",
powerAutomate_81fa07: "Power Automate",
queuedSkippedSucceededAndFailedRecipeRuns_ceb06e: "Exécutions de recettes mises en file d'attente, ignorées, réussies et échouées avec nouvelle tentative manuelle.",
noRunsHaveBeenRecordedYet_cfe5db: "Aucune exécution n’a encore été enregistrée.",
importAssetsOrContactsFromACSV_8bb4c4: "Importez des actifs ou des contacts depuis un fichier CSV ou Excel. Associez les colonnes, prévisualisez la validation, puis créez les enregistrements.",
fileIntegrationHealth_2a85ee: "État de l'intégration des fichiers",
credentialsScopeRunsUnderYourSignedinWorkspace_7e301a: "Informations d'identification/portée : s'exécute sous les autorisations de votre espace de travail connecté ; le contenu du fichier est mappé avant la création des enregistrements.",
chooseACsvOrXlsxFileThe_d63529: "Choisissez un fichier .csv ou .xlsx. La première ligne doit contenir des en-têtes de colonnes.",
chooseFileToImport_7450d5: "Choisir le fichier à importer",
whatAreYouImporting_15be02: "Qu’importez-vous ?",
startOver_51dd91: "Recommencer",
mapColumnsAndOptionalDefaults_b4665a: "Associer les colonnes et définir des valeurs par défaut facultatives",
flowFileObjectTypeAssetscontactsThisStep_1f9978: "Flux : fichier → type d'objet (actifs/contacts) → cette étape → Aperçu (validation) → Importer. Ici, choisissez quelle colonne de votre feuille de calcul alimente chaque champ de l'application. Si une colonne est manquante ou si des cellules sont vides, définissez une valeur par défaut ci-dessous : elle remplit chaque ligne où cette valeur est manquante. Les champs marqués * nécessitent une colonne ou une valeur par défaut. L'aperçu affiche les problèmes au niveau de la ligne (par exemple, un sous-type non valide pour le type d'actif de cette ligne) avant que quoi que ce soit ne soit enregistré.",
browseAllowedSubtypeValuesByAssetType_a490ea: "Parcourir les valeurs de sous-type autorisées par type d'actif",
browseAllowedSubtypeValuesByAssetType_580a2c: "Parcourir les valeurs de sous-type autorisées (par type d'actif)",
sameFieldsAsWhenYouAddAn_66723f: "Mêmes champs que lorsque vous ajoutez un actif depuis l'onglet Actifs (création rapide).",
sameToplevelFieldsAsAssetDetailsSubtype_f2742b: "Mêmes champs de niveau supérieur que Actif → Détails (listes de sous-types, de criticité et de balises). Le jeu d'options structuré JSON n'est pas importé ici : utilisez le texte brut et les valeurs de balise autorisées répertoriées dans la référence ci-dessus.",
sameAsAddContactWhoThisRecord_ba62a1: "Comme pour Ajouter un contact : la personne que représente cette fiche.",
whoCanSeeThisContactDefaultRoles_144799: "Qui peut voir ce contact ; rôles par défaut si le fichier n'en contient pas.",
defaultIfEmpty_4d3688: "Par défaut si vide",
optionalUseForEveryRowWhenBlank_6bd308: "Facultatif : à utiliser pour chaque ligne lorsqu'elle est vide",
oneDefaultSubtypeAppliesToEveryRow_1adca0: "Un sous-type par défaut s'applique à chaque ligne comportant une cellule de sous-type vide. Si votre fichier mélange des types d’actifs, cette valeur doit être valide pour tous – utilisez généralement une colonne Sous-type à la place.",
whenAMatchingRecordAlreadyExists_2bc530: "Lorsqu'un enregistrement correspondant existe déjà",
updateMatchingRecords_acbd0a: "Mettre à jour les enregistrements correspondants",
matchAssetsByExternalIDAndContacts_440e6c: "Faites correspondre les actifs par identifiant externe et les contacts par e-mail.",
skipMatchingRecords_c0ae31: "Ignorer les enregistrements correspondants",
leaveExistingAssetWRXRecordsUnchanged_8f82ad: "Laissez les enregistrements AssetWRX existants inchangés.",
everyRowHasOneExplicitActionValidation_3af4e8: "Chaque ligne comporte une action explicite. Les erreurs de validation ne seront pas écrites.",
dataToImport_06e654: "Données à importer",
valuesReadFromFileThisRowWill_bd4d2f: "Valeurs lues à partir du fichier (cette ligne ne sera pas importée)",
noNonemptyFieldsOnThisRow_33c6ae: "Aucun champ non vide sur cette ligne.",
noMappedValuesForThisRow_b90088: "Aucune valeur mappée pour cette ligne.",
importFinished_c3e89b: "Importation terminée",
created_05e8fd: "Créé ",
andMore_c2145e: "…et plus encore",
importAnotherFile_6dc962: "Importer un autre fichier",
closeSubtypeReference_be22c0: "Fermer la référence de sous-type",
subtypeValuesImport_0c957e: "Valeurs de sous-type (importation)",
useTheCodeOrLabelInThe_0a2125: "Utilisez le code ou l'étiquette dans la colonne Sous-type. La valeur doit correspondre au type d'actif sur la même ligne (ou à votre type par défaut).",
connected_3dfd4d: "connected.*",
connectedruleexecuted_594141: "connected.rule.executed",
temperature_7033e9: "temperature",
xApiKey_cef935: "X-Api-Key",
httpspartnerexamplecomhooksassetwrx_79a38c: "https://partner.example.com/hooks/assetwrx",
jobId_f3d2e2: "jobId",
status_48a366: "status",
title_3c6de1: "title",
tESTASSET001_6a6a4b: "TEST-ASSET-001",
opsCopilot_5a267c: "Copilote des opérations",
httpsmcpexamplecom_a938f2: "https://mcp.example.com",
httpsexamplecomwebhooksassetwrx_fc61e9: "https://example.com/webhooks/assetwrx",
retryTestConnection_c9f32a: "Réessayer de tester la connexion",
refreshLogs_f970c3: "Actualiser les journaux",
credentialAndScopeClarity_6593d1: "Clarté des identifiants et de la portée",
assistantAccessStillRequiresWorkspaceEnablementPlus_df3128: "L'accès de l'assistant nécessite toujours l'activation de l'espace de travail ainsi que l'approbation par outil/ressource dans le catalogue.",
retryConnectionTest_4382ef: "Réessayer le test de connexion",
whatThisWizardSetsUp_ced2db: "Ce que cet assistant configure",
thisExposesAssetWRXItselfAsAFirstparty_a9b397: "Cela expose AssetWRX lui-même en tant que serveur MCP interne pour l'espace de travail actuel. Les clients MCP externes obtiennent des lectures limitées à l'espace de travail et des outils d'écriture soumis à proposition, uniquement via le backend.",
assetWRXSystemConnector_bbcfee: "Connecteur système AssetWRX",
thisAssistantConnectorIsAlwaysAvailableFor_6e5481: "Ce connecteur assistant est toujours disponible pour l'espace de travail, masqué aux utilisateurs normaux et ne peut pas être supprimé.",
whatYouGet_8ac7aa: "Ce que vous obtenez",
proposalfirstWritesAuditHistoryAndPerworkspaceEnablement_4086cb: "Écritures soumises à proposition, historique d'audit et activation par espace de travail.",
readsExposedInV1_a02d0c: "Lectures exposées dans la v1",
workspaceSummaryDashboardStatusAssetsInspectionsJobs_ac16ca: "Résumé de l'espace de travail, état du tableau de bord, actifs, inspections, interventions, check-lists et lectures de contexte de l'assistant lorsque cela est sûr.",
builtinAssistantCapabilities_e47a5d: "Capacités intégrées de l'assistant",
writeBehaviorInV1_73d808: "Comportement d'écriture en v1",
materialToolsCreateProposalsFirstNothingCommits_9951b2: "Les outils qui modifient des données créent d'abord des propositions. Rien ne s'exécute tant qu'un propriétaire ou un administrateur ne l'a pas approuvé ici (ils sont notifiés), sauf si le propriétaire laisse cette action s'exécuter sans approbation ; le client appelle ensuite `confirm_proposed_action`.",
enableWorkspaceExposure_3b8aed: "Activer l'exposition de l'espace de travail",
turnOnTheEndpointConfirmTheWorkspace_c9acbe: "Activez le point de terminaison, confirmez l'état de l'espace de travail, et définissez la durée de validité des propositions d'écriture avant expiration.",
endpoint_92ec63: "Point de terminaison",
proposalTTLMinutes_b08405: "Durée de validité des propositions (minutes)",
validRange5To1440MinutesDefault_81859c: "Plage valide : 5 à 1 440 minutes. Par défaut : 30 minutes.",
approveToolsAndResources_6e4769: "Approuver les outils et les ressources",
keepOnlyTheWorkspacesafeMCPSurfaceYou_433b1d: "Conservez uniquement la surface MCP sécurisée pour l’espace de travail que vous souhaitez que les clients externes voient. Les lignes désactivées sont masquées dans « tools/list » et « resources/list ».",
noFirstpartyMCPToolsAreRegisteredYet_a45543: "Aucun outil MCP interne n'est encore enregistré.",
noFirstpartyMCPResourcesAreRegisteredYet_58e317: "Aucune ressource MCP interne n'est encore enregistrée.",
serviceaccountKeysAndScopes_8f39e0: "Clés et portées du compte de service",
thisWizardDoesNotMintSecretsDirectly_ba8449: "Cet assistant ne crée pas directement de secrets. Les clients MCP externes doivent utiliser les clés API du compte de service d'espace de travail existantes créées dans les clés et accès API.",
requiredScopeModel_206642: "Check-list de portée requis",
readsRequireMcpreadPlusTheRelevantDomain_efecc5: "Les lectures nécessitent `mcp:read` ainsi que la portée de lecture du domaine concerné, par exemple `assets:read`.",
writeProposalsRequireMcpinvokePlusTheRelevant_bde894: "Les propositions d'écriture nécessitent `mcp:invoke` ainsi que la portée d'écriture concernée, par exemple `jobs:write`.",
proposalConfirmationAndCancellationStayBoundTo_b8a213: "La confirmation et l'annulation de la proposition restent liées au même espace de travail et à la même clé de demande.",
clientSetupExample_dde719: "Exemple de configuration du client",
safetyDefaults_f1e85c: "Paramètres de sécurité par défaut",
neverHandOutUnlessTheClientIs_26c700: "Ne distribuez jamais `*` à moins que le client ne soit entièrement fiable. Préférez d’abord des clés en lecture seule, puis des clés distinctes capables de soumettre des propositions pour les automatisations contrôlées.",
reviewProposalsAndAuditHistory_945ebe: "Examiner les propositions et l'historique des audits",
useThisStepToConfirmExternalClients_209a95: "Utilisez cette étape pour confirmer que les clients externes lisent uniquement les ressources prévues et que les actions importantes restent soumises à proposition et peuvent être auditées.",
proposalHistory_0f9af9: "Historique des propositions",
noFirstpartyMCPProposalsYet_62c81f: "Aucune proposition MCP interne pour l'instant.",
mcpProposalApprove: "Approuver",
mcpProposalDecline: "Refuser",
mcpProposalDecideFailed: "Impossible d'enregistrer la décision",
mcpAwaitingApprovalTitle: "En attente de votre approbation ({{count}})",
mcpAwaitingApprovalHint: "Un assistant IA a demandé à effectuer ces modifications. Rien ne se passe tant que vous n'approuvez pas ; les demandes refusées ou expirées ne s'exécutent jamais.",
mcpApproveAll: "Tout approuver ({{count}})",
mcpDeclineAll: "Tout refuser ({{count}})",
mcpApproveAllConfirmTitle_one: "Approuver {{count}} demande ?",
mcpApproveAllConfirmTitle_many: "Approuver {{count}} demandes ?",
mcpApproveAllConfirmTitle_other: "Approuver {{count}} demandes ?",
mcpApproveAllConfirmBody: "Toutes les demandes « {{action}} » en attente ici sont approuvées, et l'IA pourra ensuite exécuter chacune d'elles.",
mcpDeclineAllConfirmTitle_one: "Refuser {{count}} demande ?",
mcpDeclineAllConfirmTitle_many: "Refuser {{count}} demandes ?",
mcpDeclineAllConfirmTitle_other: "Refuser {{count}} demandes ?",
mcpDeclineAllConfirmBody: "Aucune des demandes « {{action}} » en attente ici ne sera exécutée.",
mcpShowAll: "Tout afficher ({{count}})",
mcpShowFewer: "Afficher moins",
mcpApprovalRequired: "Approbation requise",
mcpApprovalNotRequired: "S'exécute sans approbation",
mcpWaiveApprovalTitle: "Laisser « {{name}} » s’exécuter sans approbation ?",
mcpWaiveApprovalBody: "Un assistant IA pourra alors effectuer ce changement sans l'approbation d'un propriétaire ou d'un administrateur. Vous pouvez réactiver l'approbation à tout moment.",
mcpWaiveApprovalConfirm: "Exécuter sans approbation",
mcpApprovalUpdateFailed: "Impossible de modifier l'approbation de cette action.",
invocationAudit_06c951: "Audit des appels",
noFirstpartyMCPInvocationHistoryYet_352e60: "Aucun historique d'appel MCP interne pour l'instant.",
assetWRXMCPExposure_b699b4: "Exposition MCP d'AssetWRX",
exposeThisWorkspaceAsAFirstpartyMCP_7fae12: "Exposez cet espace de travail comme serveur MCP interne avec des lectures limitées à l'espace de travail, des écritures soumises à proposition, et un historique d'audit.",
firstpartySetup_16908a: "Configuration interne",
loadingAssetWRXMCPExposure_4cc589: "Chargement de l'exposition MCP AssetWRX...",
loadingAssetWRXMCPExposure_ec357e: "Chargement de l'exposition MCP AssetWRX…",
workspaceControls_3cfefd: "Contrôles de l'espace de travail",
useServiceaccountKeysWithMcpreadForResources_d8fd58: "Utilisez les clés de compte de service avec « mcp:read » pour les ressources et « mcp:invoke » ainsi que les étendues d'écriture de domaine pour les outils compatibles avec les propositions.",
exposedTools_50a475: "Outils exposés",
materialActionsStayProposalfirstEvenWhenEnabled_40b9b8: "Les actions importantes restent soumises à proposition, même lorsqu'elles sont activées ici.",
exposedResources_420463: "Ressources exposées",
resourceTemplatesStayWorkspacescopedAndAreFiltered_664498: "Les modèles de ressources restent limités à l'espace de travail et sont filtrés par les portées du compte de service.",
hideMoreActions_dd5915: "Masquer plus d'actions",
hideActions_affb29: "Masquer les actions",
showMoreActions_2ff0fa: "Afficher plus d'actions",
searching_ba2b5a: "Recherche...",
aICanDraftThisRepairJob_247024: "L'IA peut rédiger cette intervention de réparation",
why_d77989: "Pourquoi ?",
autoprepFollowupJobsAndScheduleTighteningSuggested_8be7b7: "Préparation automatique, interventions de suivi et resserrement du calendrier suggérés",
reviewAutomations_a7cc10: "Examiner les automatisations",
workingOnThisText_24726e: "Je travaille sur ce texte...",
acceptIndividuallyOrInBulkEachWrites_bf195f: "Acceptez individuellement ou en masse : chacun écrit le brouillon dans l'élément correspondant ci-dessous.",
scheduledDate_b41cf0: "Date prévue",
selectADate_642b09: "Sélectionnez une date",
chooseAssignee_3f1566: "Choisir le responsable",
searchRequests_f13d82: "Rechercher des demandes",
noRequestsMatchYourSearch_a6c94d: "Aucune demande ne correspond à votre recherche.",
reportResponsePending_44c9b7: "Réponse au rapport en attente",
completionReviewPending_b4145c: "Examen d’achèvement en attente",
confirmDate_14424a: "Confirmer la date",
confirmTheScheduledDate_b2fc2c: "Confirmer la date prévue",
requestADifferentTime_0d7d3e: "Demander une heure différente",
cancelRequest_84837a: "Annuler la demande",
cancelThisRequest_f56a63: "Annuler cette demande",
preferredDate_921625: "Date souhaitée",
sendTheRescheduleRequest_b5dc9f: "Envoyer la demande de reprogrammation",
cancelTheRescheduleRequest_9fb111: "Annuler la demande de reprogrammation",
chooseNextAction_94f5b9: "Choisir l'action suivante",
chooseAWorkPathTheRequestDetails_804dd3: "Choisissez un chemin de travail ; les détails de la demande restent pré-remplis pour la confirmation, l'affectation et le calendrier.",
recommended_9ef937: "Recommandé",
createWorkFromRequest_47ff21: "Créer un travail à partir d'une demande",
confirmOwnerDueDatePriorityAndInstructions_8bc8fe: "Confirmer le propriétaire, la date d'échéance, la priorité et les instructions avant de créer l'intervention",
inspectRequest_5569d2: "Inspecter à partir de la demande",
chooseStartNowAssignOrScheduleAfter_c334b8: "Choisissez démarrer maintenant, attribuer ou planifier après avoir confirmé la liste de contrôle et la portée.",
whoApprovesWorkOnThisAsset_2e42d2: "Qui approuve les travaux sur cet actif ?",
inspectionConditionTrend_179a6f: "Évolution de l'état lors des inspections",
searchNameCompanyRole_baab25: "Rechercher le nom, l'entreprise, le rôle",
tryClearingTheSearchOrFilters_0818c7: "Essayez d'effacer la recherche ou les filtres.",
roleCompany_feef85: "Rôle · Entreprise",
changeAccess_fec7d5: "Modifier l'accès",
overdueWorkDocumentRiskAndOpenInspection_66d5d1: "Travail en retard, risques liés aux documents et inspections en cours.",
noUrgentItemsRightNow_d3111a: "Aucun élément urgent pour le moment.",
responsibleTeam_fd5898: "Équipe responsable",
approvesWork_3d9f4c: "approuve les travaux",
signsOffInspectionsAndJobCompletionsAnd_35b573: "Approuve les inspections et les interventions, et valide les documents.",
draftInProgress_82d43c: "Brouillon et en cours",
healthComplianceAndRiskAreScoredFrom_3c3736: "La santé, la conformité et le risque sont notés à partir du dossier complet et présentés au propriétaire et à l'équipe de l'actif.",
noDocumentsMatchTheCurrentFilters_193238: "Aucun document ne correspond aux filtres actuels.",
noDocumentDatesThisMonth_01f2cb: "Aucune date de document ce mois-ci.",
noDocumentsOnThisDay_ed643f: "Aucun document ce jour.",
plannedRunsWorkInFlightAndCompleted_12c7f2: "Exécutions planifiées, travail en cours et rapports terminés pour cet actif.",
startAnInspectionToEstablishConditionAnd_5e3ce5: "Démarrer une inspection pour établir l'état et effectuer les travaux de suivi.",
completedCancelledInspections_118586: "Inspections terminées et annulées",
scheduledActiveAndClosedWorkTiedTo_bdec69: "Travaux planifiés, actifs et clôturés liés à cet actif.",
noJobsForThisAsset_778118: "Aucune intervention pour cet actif",
createFollowupWorkForThisAssetWhen_346e1d: "Créez un travail de suivi pour cet actif lorsque quelque chose nécessite une action.",
completedCancelledJobs_9dae91: "Interventions terminées et annulées",
searchKnowledge_42cfc4: "Rechercher des connaissances",
addToKnowledge_52f38f: "Ajouter aux connaissances",
publicIntake_b9f61c: "Signalement public",
turnThisOnToGetAQR_7dd031: "Activez cette option pour obtenir un code QR et un lien que tout le monde peut utiliser pour signaler un problème sur cet actif – aucun compte ni connexion n'est nécessaire.",
publicIntakeQRCode_71844b: "Code QR de signalement public",
howItWorks_1dd6a1: "Comment ça marche",
"1PrintOrDisplayThisQRCode_b4b58b": "1. Imprimez ou affichez ce code QR sur ou à proximité de l'actif.",
"2AnyoneScansItWithTheirPhone_399e27": "2. N'importe qui le scanne avec l'appareil photo de son téléphone — sans application ni connexion.",
"3TheyDescribeTheIssueAndIt_0cf748": "3. Ils décrivent le problème et il se retrouve dans vos demandes.",
printThisQRCode_355b08: "Imprimer ce code QR",
printQR_3d3e5d: "Imprimer QR",
copyIntakeLink_d55587: "Copier le lien de signalement",
printOrShareTHISCodeItsThe_081cb8: "Imprimez ou partagez CE code — c'est le seul qui fonctionne sans compte. L'étiquette QR propre à l'actif ouvre l'actif pour les membres de l'équipe connectés et demandera à un tiers de se connecter.",
publicIntakeIsOnButThisApp_37c7e6: "Le signalement public est activé, mais cette version de l'application n'a pas d'adresse Web publique vers laquelle pointer le code QR ; il n'y a donc pas encore de lien à partager. Elle est définie lors de la création de la version (EXPO_PUBLIC_WEB_APP_URL) — demandez à la personne qui a produit cette version de la configurer. L'application Web n'est pas concernée.",
closePublicIntake_83ee14: "Désactiver le signalement public",
clearFilter_b667d6: "Effacer le filtre",
retire_c9714c: "Retirer définitivement",
cancelRetiring_021841: "Annuler le retrait définitif",
thisAssetIsStillInServiceTake_6d33c8: "Cet actif est toujours en service. Mettez-le d'abord hors service, puis retirez définitivement la fiche.",
decommissionThisAssetFirst_3dba4e: "Mettez d'abord cet actif hors service",
decommissionFirst_449932: "Mettre hors service en premier",
whyIsItBeingRetired_424b30: "Pourquoi est-il retiré ?",
anythingTheRecordShouldSayEgReplaced_39f4f8: "Tout ce que l'enregistrement devrait dire — par ex. remplacé par l'unité B-12.",
retirementNote_69e12e: "Note de retrait définitif",
disposalOptional_664c05: "Cession ou mise au rebut (facultatif)",
recipientBuyerScrapYardLessor_bc1312: "Destinataire — acheteur, casse, bailleur",
disposalRecipient_0bcdb7: "Destinataire de la cession",
disposalValue_7e69e8: "Valeur d'élimination",
whatHappens_d208fd: "Que se passe-t-il",
retireThisAsset_843886: "Retirer définitivement cet actif",
editSharedAccess_874a55: "Modifier l'accès partagé",
canRequestWorkLetsThemSubmitInspection_66303c: "« Peut demander du travail » leur permet de soumettre des demandes d'inspection ou d'intervention ; « Peut afficher » est en lecture seule. Les deux peuvent voir les interventions et les inspections.",
documentsArePrivateByDefaultTurnThis_f79dc7: "Les documents sont privés par défaut. Activez cette option pour leur permettre de télécharger les fichiers de l'actif.",
canDownloadDocuments_d483c0: "Peut télécharger des documents",
thisContactIsNotLinkedToAn_cfbe9b: "Ce contact n'est pas encore lié à un utilisateur de l'application. Enregistrer partagera l'actif, mais ils doivent accepter une invitation de contact avant de pouvoir le voir dans l'application.",
relationshipToThisAsset_cc572f: "Relation avec cet actif",
moreRelationships_1c2d3e: "Autres relations",
howThisContactIsLinkedOnThe_b75d5d: "Comment ce contact est lié à l'enregistrement d'actif (organisation/location). Sélectionnez une ou plusieurs relations.",
whatThisContactCanDoInThe_1f7b90: "Ce que ce contact peut faire dans l'espace de l'actif partagé. « Peut demander du travail » leur permet de soumettre des demandes d'inspection ou d'intervention ; « Peut afficher » est en lecture seule. Les deux peuvent voir les interventions et les inspections.",
saveShare_bcf6ed: "Enregistrer le partage",
qR_45e7a1: "QR",
scanOrPrintLabelsForThisAsset_c3fdde: "Numérisez ou imprimez des étiquettes pour cet actif.",
print_5b221e: "Imprimer",
qRCodeWillBeGeneratedWhenAsset_31ea4e: "Le code QR sera généré lors de l'enregistrement de l'actif",
assetIntelligence_d0cf4b: "Intelligence des actifs",
conditionNotRatedYet: "État non évalué pour l’instant · inspection nécessaire",
why_21e2ca: "Pourquoi",
keepTheCurrentSchedule_ade385: "Conserver la planification actuelle",
keepCurrentSchedule_24ceb0: "Conserver la planification actuelle",
operationalReadiness_f83f30: "Disponibilité opérationnelle",
noReadinessChecksCurrentlyNeedAttention_8a0ffe: "Aucun contrôle de préparation ne nécessite actuellement votre attention",
foundations_2efa1e: "Fondations",
topCommandsForThisAsset_43db45: "Principales commandes pour cet actif",
seeAll_9ff264: "Voir tous →",
noCompletedOrApprovedInspectionCyclesAre_58ad5b: "Aucun cycle d’inspection terminé ou approuvé n’est enregistré.",
noLinkedAssetsYet_f0421d: "Aucun actif lié pour l'instant.",
viewRelationships_855c37: "Afficher les relations →",
noOpenJobsOrInprogressInspectionsAre_c07385: "Aucune intervention ouverte ni inspection en cours n'est enregistrée.",
sharedContactsAndQRScannersReportIssues_ece9d2: "Les contacts partagés et les personnes qui scannent le QR signalent les problèmes directement dans votre file de travail.",
addArticle_2f4275: "Ajouter un article",
shareLibrary_4057e3: "Partager la bibliothèque",
signInToSeeThisKnowledge_4eaa03: "Connectez-vous pour voir ces connaissances",
yourSessionHasExpiredSoTheseArticles_f87fa2: "Votre session a expiré, ces articles ne peuvent donc pas être chargés. Connectez-vous à nouveau pour continuer.",
couldnrsquotLoadKnowledge_da1c79: "Impossible de charger les connaissances",
tryLoadingKnowledgeAgain_1b6aa1: "Essayez à nouveau de charger les connaissances",
refineArticles_d1b417: "Affiner les articles",
kind_e00ac2: "Type",
egElectrical_0b7339: "par ex. électrique",
egBoilerAnnual_18e665: "par ex. chaudière, annuelle",
pinnedOnly_bd8de5: "épinglé uniquement",
egBoilerResetProcedure_91545f: "p. ex. Procédure de réinitialisation de la chaudière",
uRL_0e2d9b: "URL",
https_1a6627: "https://…",
content_4f9be0: "Contenu",
writeStepsAnswerOrNotes_974f8b: "Écrivez des étapes, des réponses ou des notes…",
chooseFile_3fd558: "Choisir le fichier…",
setTitlecategoryAboveBeforeUploadingOptional_cea97d: "Définissez le titre/la catégorie ci-dessus avant de télécharger (facultatif).",
shortSummaryOrContext_239731: "Bref résumé ou contexte",
pinned_f93121: "épinglé",
shareKnowledge_a28e38: "Partager les connaissances",
shareWith_134bfa: "Partager avec",
chooseContactToShareWith_f8c887: "Choisissez le contact avec lequel partager",
noEmailOnContact_2730d7: "Aucune adresse e-mail pour ce contact",
chooseContact_4a3f8f: "Choisissez le contact…",
createLinkCopy_460e24: "Créer un lien et copier",
activeShares_8d41b3: "Partages actifs",
revokeShare_1d9e95: "Révoquer le partage",
addAtLeastTwoAssetsInThis_92640d: "Ajoutez au moins deux actifs dans cette étendue pour créer des liens entre eux.",
startInWork_47c346: "Démarrer dans Travail",
propertyCategory_dfd0bc: "Catégorie de bien",
propertySubtype_7092d7: "Sous-type de bien",
vehicleClass_1807bf: "Classe de véhicule",
equipmentClass_f1c8f7: "Classe d'équipement",
domain_9b1091: "Domaine",
furnished_8ab38e: "Meublé",
operatingContext_c28bb5: "Contexte d'exploitation",
usageType_0193f0: "Type d'utilisation",
mounting_26ae06: "Montage",
safetyClass_c2825e: "Classe de sécurité",
environment_d443a1: "Environnement",
riskTags_391936: "Étiquettes de risque",
otherAssetCategory_c3e627: "Autre catégorie d'actif",
propertySystems_2983a3: "Systèmes du bien",
conditionFlags_0fd793: "Indicateurs d'état",
transmission_ace17e: "Transmission",
lastServiceDate_6a44ff: "Date du dernier entretien",
roadworthinessExpiry_a32510: "Expiration du contrôle technique",
insuranceExpiry_5788c0: "Expiration de l'assurance",
capacityUnit_f595ba: "Unité de capacité",
useStructuredOptionSetsSoTemplateRecommendation_a4913e: "Utilisez des jeux d'options structurés pour que la recommandation et la génération de check-lists restent claires.",
addOneOrMoreRelationshipsNowOr_bdce2c: "Ajoutez une ou plusieurs relations maintenant, ou laissez ce champ vide pour conserver cet actif autonome.",
noDraftRelationshipsAddedYet_0698d2: "Aucune relation brouillon ajoutée pour l'instant.",
chooseTheRelatedAsset_35789f: "Choisissez l'actif associé",
fromThisAsset_48c52c: "À partir de cet actif",
toThisAsset_f70126: "Vers cet actif",
relationshipCriticality_1a33c6: "Criticité de la relation",
riskPropagationMode_720d7e: "Mode de propagation des risques",
propagationMode_fa66d1: "Mode de propagation",
noAssetsToVisualizeYet_c42bdd: "Aucun actif à visualiser pour l'instant.",
links_014bcd: "Liens",
display_574ff9: "Affichage",
viewAffectedWork_acb250: "Voir le travail concerné →",
relationshipTypes_558b4b: "Types de relations",
clickToEditOrRemove_8526e9: "Cliquez pour modifier ou supprimer",
understandingRisk_2e43d7: "Comprendre le risque",
whatRaisesOrLowersLikelihood_622b19: "Ce qui augmente ou diminue la probabilité",
whatRaisesOrLowersImpact_767cc7: "Ce qui augmente ou diminue l'impact",
noRelationshipbasedAdjustmentsToShow_47ffe9: "Aucun ajustement basé sur la relation à afficher.",
likelihoodMixScoreWeightContribution_2582ca: "Composition de la probabilité (score × pondération = contribution)",
impactMix_ec0686: "Composition de l'impact",
rawWeightedValues_f4522d: "Valeurs brutes pondérées",
assetRisk_54b50c: "Risque de l'actif",
"55Matrix_f6b01d": "Matrice 5×5",
topDrivers_f8f235: "Principaux facteurs",
whyThisRiskScore_6c74da: "Pourquoi ce score de risque ?",
mo_e9e0ce: "/mois",
aW_073d87: "AW",
suggestedNextStep_4a96db: "Prochaine étape suggérée : ",
complianceAndAudit_d16087: "Conformité et audit",
moreInBreakdown_3e1121: "+ plus dans le détail",
opensMapsWithDirectionsFromYourLocation_44a789: "Ouvre l'application de cartes avec l'itinéraire depuis votre position",
closeDocument_7866c7: "Fermer le document",
openingFile_c515cb: "Ouverture du fichier",
notDisplayingOpenItInYourBrowser_a5761f: "Ne s'affiche pas ? Ouvrez-le dans votre navigateur.",
openInBrowser_052269: "Ouvrir dans le navigateur",
noInappPreview_37df05: "Pas d'aperçu dans l'application",
previewUnavailable_36d31d: "Aperçu indisponible",
thisDocumentCouldNotBeDisplayedHere_e78b36: "Ce document n'a pas pu être affiché ici. Utilisez « Ouvrir dans le navigateur » ci-dessous pour le lire.",
theDocumentRendererIsUnavailableInThis_3dc0a5: "Le moteur de rendu de documents n'est pas disponible dans cette version. Utilisez « Ouvrir dans le navigateur » ci-dessous.",
loadingDocument_77cac7: "Chargement du document",
couldNotReadThisFile_fce43e: "Impossible de lire ce fichier",
theFileCouldNotBeDownloadedUse_fd63bb: "Le fichier n'a pas pu être téléchargé. Utilisez « Ouvrir dans le navigateur » ci-dessous ou réessayez lorsque vous disposez d'une connexion stable.",
loadingVideo_c18920: "Chargement de la vidéo",
workArrivesFromTheFieldAQR_d69f49: "Le travail arrive du terrain, d'un scan QR ou d'un demandeur, puis suit la boucle jusqu'à la vérification.",
howAssetWRXWorks_a6652b: "Comment fonctionne AssetWRX",
theEverydayLoopEndToEndTap_f41cec: "La boucle quotidienne, de bout en bout. Appuyez sur n’importe quelle étape pour y accéder.",
howToGetTheMostOutOf_6ecde4: "Comment tirer le meilleur parti de AssetWRX — par tâche, avec des procédures pas à pas interactives.",
loadingInspectionDetails_07441a: "Chargement des détails de l'inspection...",
weCouldntLoadThisInspection_0d9c6e: "Nous n'avons pas pu charger cette inspection",
loadingChecklist_6d4b18: "Chargement de la liste de contrôle…",
inspectionDetails_f70991: "Détails de l'inspection",
thisInspectionWasCreatedFromARequest_62e54f: "Cette inspection a été créée à partir d'une demande et reste liée à la chronologie de sa demande.",
openSourceRequest_847fb2: "Ouvrir la demande d'origine",
clearSkip_6abff6: "Effacer le saut",
clearsSkipSoYouCanAnswerThis_fdd91c: "Efface le saut afin que vous puissiez répondre à cet élément.",
useYesNoPassFailStarsOrSkipBelow_c5d2c7: "Utilisez Oui/Non, Réussite/Échec, étoiles ou Sauter sous le titre pour répondre.",
unskipItem_a158ab: "Annuler le saut de l'élément",
unskip_cde472: "Annuler",
skipItem_cb392b: "Sauter l'élément",
opensAShortFormYouCanSkip_8bc9f3: "Ouvre un formulaire court. Vous pouvez sauter avec ou sans note.",
notConfirmed_b9e09a: "Non confirmé",
evidenceRecommendedAddAPhotoOfThe_f5d5bd: "Preuve recommandée : ajoutez une photo du problème.",
noVideosRecorded_803350: "Aucune vidéo enregistrée",
upTo3Photos1VideoMax_382f91: "Jusqu'à 3 photos · 1 vidéo, max 20 s",
inspectionAttachments_4eccaa: "Pièces jointes de l'inspection",
skipTheCurrentGroupOfItemsBecause_22712a: "Ignorer le groupe d'éléments actuel car aucun ne s'applique",
skipThisGroup_348a6d: "Ignorer ce groupe",
keyboardShortcuts_266695: "Raccourcis clavier",
closeKeyboardShortcuts_b87b09: "Fermer les raccourcis clavier",
requestConversation_7db6bd: "Conversation de la demande",
retryExport_f58f53: "Réessayer l'exportation",
completedTheWork_099993: "Travaux terminés",
notSharedYetUseShareAboveTo_81bebb: "Pas encore partagé — utilisez Partager ci-dessus pour envoyer ce rapport à un contact.",
couldNotGenerateReport_fb1286: "Impossible de générer le rapport",
showAllDetails_c5a7a8: "Afficher tous les détails",
neededBeforeCompletion_304a39: "Nécessaire avant la fin",
completionProgress_e2e2b3: "Progression de l'achèvement",
latestUpdate_749cd8: "Dernière mise à jour",
noUpdatesYet_24f53d: "Aucune mise à jour pour l'instant.",
beforeYouSubmit_ede7c3: "Avant de soumettre :",
invoiceExtraction_b8d23c: "Extraction de factures",
reviewExtractedItems_9649fe: "Examiner les éléments extraits",
noLineItemsDetectedTryAClearer_7ebd61: "Aucune ligne détectée. Essayez une photo plus nette ou ajoutez des lignes manuellement.",
removeLineItem_68fb55: "Supprimer la ligne",
useCalculated_7192f0: "Utiliser le montant calculé",
leaveBlankToRecordAs0Enter_74cafa: "Laissez vide pour enregistrer comme 0. Entrez le montant total de cette intervention.",
addLineItem_2932d8: "Ajouter une ligne",
invoiceOrReceipt_bcd947: "Facture ou reçu",
attached_8e632c: "Attaché",
pDFImageOrWordDocument_812ab0: "PDF, image ou document Word.",
whyThisJobWasSuggested_e32a41: "Pourquoi cette intervention a été suggérée",
what3words_881ff5: "what3words",
filledcountsoap_1a66d3: "///filled.count.soap",
nothingToChooseFromYet_978c4e: "Rien à choisir pour l'instant.",
reportNotAvailable_c048c4: "Rapport non disponible",
thisLinkMayBeInvalidOrThe_0e72cd: "Ce lien est peut-être invalide ou le rapport n'est plus partagé.",
itemsChecked_34daa1: "Éléments vérifiés",
needAttention_46d04d: "Besoin d'attention",
seeTheFullReport_d02b8d: "Voir le rapport complet",
signInToRequestAccess_2e7a0e: "Connectez-vous pour demander l'accès",
requestSentTheTeamManagingThisAsset_56c7e0: "Demande envoyée. L'équipe qui gère cet actif l'examinera. Vous serez averti lorsqu'elle répondra.",
theTeamManagingThisAssetDeclinedThis_072c77: "L'équipe gérant cet actif a refusé cette demande. Contactez-les directement si vous pensez que vous devriez y avoir accès.",
yourRelationshipToThisAsset_088c6c: "Votre relation avec cet actif",
selectARole_de9e0a: "Sélectionnez un rôle",
anythingToAddOptional_d0e207: "Quelque chose à ajouter ? (facultatif)",
egImTheTenantAtThisProperty_900046: "par ex. Je suis locataire de cette propriété",
staySignedIn_e5f5f7: "Rester connecté",
signatureCanvas_b150c4: "Zone de signature",
opensTheTimeSelector_03fd5a: "Ouvre le sélecteur d'heure",
rowDensity_0a44a7: "Densité des lignes",
pullingTheLatestActivityForThisRequest_3eb3bd: "Chargement de la dernière activité de cette demande.",
selectARequest_e23d7c: "Sélectionnez une demande",
chooseARequestToSeeItsDetail_17587d: "Choisissez une demande pour voir son détail et son activité.",
caseTimeline_ea3757: "Chronologie de la demande",
addACheck_a948e9: "Ajouter une vérification",
cancelAddingACheck_a8ca4e: "Annuler l'ajout d'une vérification",
searchChecklists_bf435d: "Rechercher des listes de contrôle…",
buildANewChecklistToUseAs_eeb155: "Créer une nouvelle liste de contrôle à utiliser comme contrôle",
buildANewChecklist_4597c6: "Créer une nouvelle liste de contrôle",
requireThisCheckBeforeTheJobCan_75004c: "Exiger cette vérification avant que l'intervention puisse être complétée",
requiredToCompleteTheJob_93fe15: "Requis pour compléter l'intervention",
offByDefaultARequiredCheckBlocks_83f24c: "Désactivé par défaut. Une vérification obligatoire bloque l'achèvement jusqu'à ce qu'elle soit terminée.",
sendACalendarInviteToSomeoneAt_1ef692: "Envoyer une invitation d'agenda à une personne sur place",
optionalTheyllGetAnEmailCalendarInvite_f3c0fa: "Facultatif : ils recevront une invitation par courrier électronique (.ics) pour ce créneau horaire.",
inviteToCalendar_f4347a: "Inviter au calendrier",
thisCheckHasNoSteps_3d81af: "Cette vérification ne comporte aucune étape",
checkChangedTitle: "Quelqu’un d’autre a mis à jour cette vérification",
checkChangedBody: "Ses réponses sont affichées. Répondez à nouveau là où c’est nécessaire.",
theTemplateItCameFromIsEmpty_dee3b8: "La check-list dont il provient est vide. Modifiez la check-list pour ajouter des étapes, puis attachez-le à nouveau.",
savedOnThisDeviceWillSyncWhen_3db4e0: "Enregistré sur cet appareil — sera synchronisé lorsque vous serez de nouveau en ligne",
prepareWork_8aa4da: "Préparer le travail",
loadingWorkContext_c860da: "Chargement du contexte de travail",
reopenCase_a32ef8: "Rouvrir la demande",
reopen_61e05d: "Rouvrir",
conversation_2a20c7: "Conversation",
writeAReply_dd081e: "Écrire une réponse…",
escalated_aff666: "remonté",
closeWithoutAResponse_3bf706: "Fermer sans réponse",
closeWithoutResponse_6c6096: "Fermer sans réponse",
automateThisChase_49d451: "Automatiser cette relance",
couldntLoadYourTemplates_b41115: "Impossible de charger vos check-lists",
upcomingVisits_ecb005: "Visites à venir",
theTeamHasPlannedWorkHereAnd_78e2ed: "L'équipe a planifié des travaux ici et vous a demandé de confirmer que quelqu'un peut être présent.",
whoWillLetUsIn_66de4a: "Qui nous laissera entrer ?",
noOneNeeded_4ab28b: "Personne n'est nécessaire",
theyaposllBeAskedToConfirmTheVisit_d8cb82: "Il leur sera demandé de confirmer l'heure de la visite ou d'en suggérer une autre.",
sort_8b335a: "Trier :",
egReplaceWornBelt_49815f: "par ex. Remplacer la courroie usée",
tryLoadingChecklistsAgain_bd84f3: "Essayez à nouveau de charger les listes de contrôle",
noChecklistMatchesThisAssetTypeYet_d47d21: "Aucune liste de contrôle ne correspond encore à ce type d'actif.",
createAChecklist_02f012: "Créer une liste de contrôle",
createANewChecklistTemplate_ec189b: "Créer un nouvelle check-list de liste de contrôle",
newChecklist_d80825: "Nouvelle liste de contrôle",
when_b2028c: "Quand ?",
chooseWhenThisWorkShouldHappen_78b867: "Choisissez quand ce travail doit avoir lieu",
later_56e2f5: "Plus tard",
howLongWillItTake_5c9649: "Combien de temps cela prendra-t-il ?",
suggestedTimes_aa2e2b: "Horaires suggérés",
noSlotFitsBeforeTheDueDate_8c442c: "Aucun créneau ne correspond avant la date d'échéance : le travail nécessite plus de temps, un autre responsable ou une date limite décalée.",
howToRunIt_5809c8: "Comment l'exécuter",
endsOptional_92d6de: "Fin (facultatif)",
maxTimes_e58588: "Nombre maximal d'occurrences",
advanceTheSeries_2f1cf7: "Avancez la série",
skipARunIfThePreviousOne_1b5907: "Ignorer la suivante si la précédente est encore ouverte",
remindMe_25df3f: "Rappelez-moi",
anythingTheInspectorShouldKnow_af9eeb: "Tout ce que l'inspecteur devrait savoir",
assignTo_cc7907: "Attribuer à",
theContractorYouAwardOrHandThis_9cbde2: "Le sous-traitant à qui vous attribuez ou remettez cette intervention. Le choisir ici ne l'assigne pas — c'est l'attribution qui le fait.",
checks_5098dd: "Vérifications",
optionalAPrecheckConfirmsItIsSafe_db4e1f: "Facultatif. Une vérification préalable confirme que vous pouvez démarrer en toute sécurité ; une vérification finale confirme les travaux avant de partir. Les vérifications ajoutées ici sont obligatoires : l'intervention ne peut pas être terminée tant qu'elles ne sont pas faites.",
analysingOnDevice_54be55: "Analyse sur l'appareil…",
codes_199993: "Codes",
meterReadings_a3c12c: "Relevés de compteur",
dates_842b7b: "Dates",
detected_74fb2c: "détecté",
extractedText_5ea632: "Texte extrait",
noInformationWasExtractedOnDevice_80b803: "Aucune information n’a été extraite sur l’appareil.",
enhancingWithAI_8078cd: "Amélioration par l'IA…",
aIEnhancementWillBeAvailableWhenYoure_ff5c7e: "L'amélioration par l'IA sera disponible lorsque vous serez de nouveau en ligne. Tout ce qui a été lu sur cet appareil est enregistré.",
summariseJourney_846b25: "Résumer le parcours",
loadedMatchesMoreAssetsAreAvailable_b38944: "{{value1}} résultats chargés. D’autres actifs sont disponibles.",
showing_6ec0cc: "Affichage : {{value1}}",
organisations_b83a9b: "Organisations{{value1}}",
openJobs_31f2a1: "Interventions ouvertes{{value1}}",
viewAll_f6220a: "Tout voir · {{value1}}",
latest_a94fea: "Dernier : {{value1}}",
previous_b3f133: "Précédent : {{value1}}",
risk_ad0435: "Risque : {{value1}} ({{value2}})",
health_c90470: "Santé : {{value1}} ({{value2}})",
compliance_49ba65: "Conformité : {{value1}} ({{value2}})",
confidenceReviewBeforeApplying_a8e435: "{{value1}} confiance {{value2}}. Vérifiez avant d’appliquer.",
confidenceReviewBeforeApplying_050de9: "{{value1}} {{value2}} % de confiance. Vérifiez avant d’appliquer.",
itWillBeCreatedAsCommissionIt_d1903a: "Il sera créé comme {{value1}}. Mettez-le en service depuis la page de l’actif quand il est prêt — une inspection, puis les interventions qu’elle génère.",
upToPhotosOptionalTapThePreview_750506: "Jusqu’à {{value1}} photos — facultatif. Touchez l’aperçu ou utilisez les boutons ci-dessous.",
tapToAddAnother_f06704: "Touchez pour en ajouter une autre ({{value1}}/{{value2}})",
upToPhotosTotal_59c8b8: "Jusqu’à {{value1}} photos au total",
headsUpAlreadyUsesThisIDSerial_108120: "Attention : « {{value1}} » utilise déjà cet identifiant / numéro de série.",
mo_8759d1: "{{value1}} mois",
upToPhotosOptionalSameAsWhen_a03894: "Jusqu’à {{value1}} photos (facultatif). Comme à la création d’un actif — touchez l’aperçu ou utilisez Appareil photo / Galerie pour en ajouter.",
addAnotherPhoto_634f18: "Ajouter une autre photo ({{value1}}/{{value2}})",
groups_104467: "Groupes : {{value1}}",
items_b74542: "Éléments : {{value1}}",
required_40bdfd: "Obligatoires : {{value1}}",
conditionalRules_047d88: "Règles conditionnelles : {{value1}}",
currentVersionIsVSavingFromThis_07a9f2: "La version actuelle est la v{{value1}}. Enregistrer depuis cet éditeur créera la v{{value2}}.",
categories_5b1690: "Catégories : {{value1}}",
depth_5fb610: "Profondeur : {{value1}}",
evidence_6674e1: "Preuves : {{value1}}",
objectiveLengthChars_a7cb1d: "Longueur de l’objectif : {{value1}} caractères",
runID_27348d: "ID d’exécution : {{value1}}",
estimatedDurationMin_a210a3: "Durée estimée : {{value1}} min",
responseDeadline_834634: "Date limite de réponse : {{value1}}",
targetStart_cb37f8: "Début visé : {{value1}}",
targetEnd_f9f809: "Fin visée : {{value1}}",
estimatedBudget_070f47: "Budget estimé : {{value1}} {{value2}}",
attachedPhotos_740082: "Photos jointes · {{value1}}",
category_5e6549: "Catégorie : {{value1}}",
urgency_3bf5ac: "Urgence : {{value1}}",
dueDate_279007: "Date d’échéance : {{value1}}",
type_45c583: "Type : {{value1}}",
pleaseRespondBy_ec61f2: "Merci de répondre avant le {{value1}}",
playVideo_dbbc47: "Lire la vidéo {{value1}}",
yourReason_882f62: "Votre motif : « {{value1}} »",
twofactorOfEnrolled_3402d7: "Vérification en deux étapes : {{value1}} sur {{value2}} inscrits",
currencyCommunication_43aa12: "Devise : {{value1}} · Communication : {{value2}}",
errorsInView_5612eb: "Erreurs dans la vue : {{value1}}",
when_f062b4: "Quand : {{value1}}",
locale_469d05: "Langue : {{value1}}",
credits_ae86ee: "Crédits : {{value1}} ({{value2}})",
entity_1fba91: "Entité : {{value1}}",
step_0d893e: "Étape {{value1}}",
lastSuccessfulSyncLastFailedSyncNone_8b8bea: "Dernière synchronisation réussie : {{value1}} · Dernière synchronisation échouée : aucune enregistrée",
credentialSecretHiddenAfterCreationRotatedRevoked_326665: "Identifiant : secret masqué après création · renouvelé {{value1}} · révoqué {{value2}}",
status_ac4b0a: "Statut : {{value1}}",
lastSuccessfulSync_d6b22a: "Dernière synchronisation réussie : {{value1}}",
lastFailedSync_e7a87b: "Dernière synchronisation échouée : {{value1}}",
logsHistory_117ea0: "Journaux / historique : {{value1}}",
suggested_bfc937: "Suggéré : {{value1}} · {{value2}} %",
row_69394c: "Ligne {{value1}}",
updated_3ada36: "Mis à jour : {{value1}}",
newSitesCreated_a610d0: "Nouveaux sites créés : {{value1}}",
skippedByConflictPolicy_e92870: "Ignorés par la règle de conflit : {{value1}}",
failed_1c734b: "Échoués : {{value1}}",
pOST_39bb77: "POST {{value1}}",
credentialTokenRotated_3254bf: "Identifiant : jeton {{value1}} {{value2}}...{{value3}} · renouvelé {{value4}}",
invocations_1e09a7: "{{value1}} appels",
lastSuccess_204f28: "Dernier succès : {{value1}}",
lastFailure_fe19b0: "Dernier échec : {{value1}}",
authTypeHeader_b1a0ff: "Type d’authentification : {{value1}}. En-tête : {{value2}}.",
secretState_e4463d: "État du secret : {{value1}}.",
request_65ee72: "Requête : {{value1}}",
response_7fff2f: "Réponse : {{value1}}",
statusRecentAssistantInvocations_a6c770: "Statut : {{value1}} • appels récents de l’assistant : {{value2}}",
lastInvocation_8b8558: "Dernier appel : {{value1}}",
lastError_e74e5f: "Dernière erreur : {{value1}}",
aHostedMCPEndpointForThisWorkspace_2ee242: "Un point de terminaison MCP hébergé pour cet espace de travail : {{value1}}",
toolsAndResourcesEachFilteredByWorkspace_bdcaa8: "{{value1}} outils et {{value2}} ressources, chacun filtré par espace de travail et par les portées du compte de service.",
reads_a89270: "Lectures : {{value1}}",
writes_532f15: "Écritures : {{value1}}",
path_676484: "Chemin : {{value1}}",
scopes_993717: "Portées : {{value1}} {{value2}}",
expiresCreated_8b46c7: "Expire {{value1}} • créé {{value2}}",
preview_36c78a: "Aperçu : {{value1}}",
ms_588b6b: "{{value1}} ms • {{value2}}",
credits_05f92c: "{{value1}} crédits",
checks_05efc2: "{{value1}}{{value2}} % · {{value3}} contrôles",
dataQuality_984221: "{{value1}} · {{value2}} % de qualité des données",
reason_74bb8e: "Motif : {{value1}}",
showingRequestsFrom_dc8278: "Demandes affichées à partir de {{value1}}.",
typeToConfirm_fac0ca: "Saisissez {{value1}} pour confirmer",
lastCycles_9f5334: "{{value1}} derniers cycles",
openWork_cc107a: "Travail ouvert · {{value1}}",
tags_6e1f36: "Étiquettes : {{value1}}",
team_fff0a5: "Équipe : {{value1}}",
compliance_89f882: "Conformité · {{value1}}",
registered_8b441e: "Enregistré {{value1}}",
ofCoreFieldsFilled_0f25e0: "{{value1}} champs essentiels renseignés sur {{value2}}",
stillMissing_f3dd5e: "Manque encore : {{value1}}",
appliedReviewTheFieldsBelowTheySave_866743: "{{value1}} {{value2}} appliqué(s) — vérifiez les champs ci-dessous ; ils s’enregistrent automatiquement.",
poor_904815: "{{value1}} mauvais",
watch_a1d644: "{{value1}} à surveiller",
good_aaf5c2: "{{value1}} bon",
unscored_e4e509: "{{value1}} non noté",
criticality_b7cd47: "Criticité {{value1}} · {{value2}}",
open_a1601a: "{{value1}} {{value2}} ouvert(s)",
lastInspected_71de34: "Dernière inspection · {{value1}}",
rulesCalculated_3cece2: "Règles {{value1}} · Calculé {{value2}}",
likelihoodImpact_b6a9fb: "Probabilité {{value1}} × Impact {{value2}}",
"5Weight_d64551": "{{value1}}/5 · {{value2}} · {{value3}} % de pondération",
standaloneScoresBeforeLinkAdjustmentLI_1c934f: "Scores individuels avant ajustement des liens : P {{value1}} · I {{value2}}",
relationshipAdjustmentsAppliedLI_17818d: "Ajustements de relation appliqués : P {{value1}}{{value2}} · I {{value3}}{{value4}}",
lRawRoundedIRawRounded_c4c6f6: "P brut {{value1}} → arrondi {{value2}} ; I brut {{value3}} → arrondi {{value4}}",
rules_4b3591: "Règles {{value1}}{{value2}}",
skipped_2fd804: "Ignoré{{value1}}",
reportRef_4ee599: "Réf. du rapport : {{value1}}",
completed_57e944: "Terminé {{value1}}",
round_6178c9: "Tour {{value1}} · {{value2}}",
firstShared_249645: "Premier partage {{value1}}{{value2}}",
dueBy_d51c85: "À faire avant le {{value1}}",
scheduledFor_37e8f3: "Planifié pour le {{value1}}",
confidence_615dda: "Confiance : {{value1}}",
useExtractedTotalAsActualCost_463a4f: "Utiliser le total extrait{{value1}}{{value2}} comme coût réel",
fromQtyUnit_c1c1c3: "Depuis qté × unité : {{value1}}{{value2}}{{value3}}",
estimate_3a8133: "Estimation : {{value1}}",
actual_e5762d: "Réel : {{value1}}",
vsEstimate_5939a7: "vs estimation : {{value1}}{{value2}}{{value3}} ({{value4}}{{value5}} %)",
materialsSubtotal_f5bcb3: "Sous-total matériaux : {{value1}}{{value2}}",
inspected_517599: "Inspecté {{value1}}",
theFullReportFindingsPhotosRecommendationsAnd_e1e094: "Le rapport complet — constats, photos, recommandations et coûts éventuels — n’est partagé qu’avec les personnes approuvées. {{value1}}",
selected_deace8: "{{value1}} sélectionné(s)",
signedBy_06a094: "Signé par {{value1}}",
tapSummariseJourneyToTryAgain_f327c1: "{{value1}} Touchez « Résumer le parcours » pour réessayer.",
},
close: "Fermer",
back: "Retour",
next: "Suivant",
detailTabs: {
  scrollForward: "Afficher plus d’onglets",
  scrollBack: "Afficher les onglets précédents",
},
freePeriod: {
  until: "Gratuit jusqu’au {{date}}. Choisissez un forfait pour que votre espace de travail continue de fonctionner ensuite.",
  ended: "Votre période gratuite est terminée et votre espace de travail est en lecture seule. Choisissez un forfait pour continuer. Rien n’a été supprimé.",
},
aiReport: {
  link: "Signaler",
  title: "Signaler cette réponse de l’IA",
  body: "Dites-nous ce qui ne va pas. Nous conservons le texte affiché pour pouvoir le vérifier.",
  offensive: "Offensante",
  harmful: "Dangereuse ou nuisible",
  wrong: "Fausse ou trompeuse",
  cancel: "Annuler",
  sentTitle: "Signalement envoyé",
  sentBody: "Merci. Nous examinons chaque signalement.",
  failedTitle: "Impossible d’envoyer le signalement",
},
collaboratorUpgrade: {
contractorTitle: "Gérez vos propres interventions et clients",
contractorBody: "Suivez ici vos propres clients, interventions et factures, avec vos propres crédits d’IA. Le travail que vous faites pour d’autres reste inchangé.",
requesterTitle: "Tenez votre propre carnet d’entretien",
requesterBody: "Suivez les biens et équipements dont vous vous occupez vous-même, avec leurs interventions, inspections et documents. Ce qui est partagé avec vous reste inchangé.",
recipientTitle: "Inspectez vos propres actifs ainsi",
recipientBody: "Réalisez des inspections et des rapports comme celui-ci sur vos propres actifs. Ce qui est partagé avec vous reste inchangé.",
otherTitle: "Gérez vos propres actifs",
otherBody: "Créez votre propre espace de travail pour vos actifs et votre travail. Ce que vous faites pour d’autres reste inchangé.",
cta: "Voir les offres",
freeReady: "Votre espace de travail est prêt. Ajoutez votre premier actif avec le bouton +.",
},
aiCost: {
included: "Offert par {{host}} · {{n}} crédits restants ce mois-ci",
includedUsed: "{{host}} n’offre plus d’IA ce mois-ci. Vous pouvez utiliser vos propres crédits.",
  generateFailed: "Le brouillon n’a pas pu être rédigé. Réessayez, ou créez la liste vous-même.",
  buy: "Acheter des crédits",
  onWeb: "Les crédits s’achètent sur AssetWRX depuis le web, ou arrivent avec vos crédits mensuels.",
  buyHint: "Achetez un pack de crédits pour continuer, ou attendez vos crédits mensuels.",
  askAdmin: "Demandez au propriétaire ou à un administrateur de l’espace d’acheter des crédits, ou attendez vos crédits mensuels.",
  askNamed: "Demandez à {{name}} d’acheter des crédits, ou attendez vos crédits mensuels.",
  shortUnknown: "Il ne reste pas assez de crédits IA pour cela.",
  short: "Crédits insuffisants : il en faut {{n}}, il en reste {{balance}}.",
  hint: "Crédits IA utilisés : {{n}} · Disponibles : {{balance}}",
},
aiGenerate: {
  discard: "Abandonner",
  keep: "Le garder",
  discardBody: "Il ne sera pas enregistré. Vous pouvez en rédiger un nouveau depuis le formulaire.",
  discardTitle: "Abandonner ce brouillon ?",
  saveDraft: "Enregistrer le brouillon",
  unsavedMessage: "Votre brouillon de check-list IA n’est pas encore enregistré. Quitter et le perdre ?",
  leaveReviewTitle: "Quitter la révision ?",
  savedTitle: "Check-list enregistré",
  feedbackFailedBody: "Impossible d’enregistrer l’avis. La check-list a bien été enregistré.",
  goToTemplate: "Voir la check-list",
  saveFailed: "Impossible d’enregistrer la check-list.",
  leaveReviewBody: "Votre brouillon ne sera pas enregistré. Abandonnez-le depuis l’écran de révision pour laisser un avis.",
  stay: "Rester",
  moreOptionsSummary: "Durée, photos, ordre et style",
  moreOptions: "Plus d’options",
  baseLabel: "Copier le style de (facultatif)",
  goal: {
    fail_only_evidence: "Photos seulement en cas d’échec",
    physical_flow: "L’ordre de la visite",
    compliance: "Respect des règles",
  },
  goalLabel: "L’organiser aussi pour (facultatif)",
  evidence: {
    always: "Pour chaque point",
    optional: "Quand l’inspecteur le souhaite",
    fail_only: "Seulement en cas d’échec",
  },
  evidenceLabel: "Quand demander des photos",
  depth: {
    detailed: "Approfondi",
    standard: "Normal",
    lite: "Contrôle rapide",
  },
  depthLabel: "Niveau de détail",
  noAsset: "Aucun actif en particulier",
  basePlaceholder: "Choisissez une check-list de liste dont copier le style",
  baseSelected: "Sélectionné",
  baseNone: "Aucun",
},
aiDisclosure: {
title: "Les fonctions d'IA utilisent Google",
body: "AssetWRX envoie les photos et le texte concernés à Google (Gemini) pour cela. Google ne s’en sert pas pour s’entraîner. Les photos de preuve que vous gardez depuis Vision peuvent améliorer WRX Vision, sauf si le propriétaire de l’espace le désactive. Détails dans Profil → Confidentialité et données.",
allow: "Autoriser",
notNow: "Pas maintenant",
declined: "L'IA n'a pas été utilisée. Vous pourrez l'autoriser la prochaine fois que vous utiliserez une fonction d'IA.",
},
sessionExpiryBanner: {
expiresIn_one: "Votre session expirera dans {{count}} minute.",
expiresIn_many: "Votre session expirera dans {{count}} de minutes.",
expiresIn_other: "Votre session expirera dans {{count}} minutes.",
},
offlineStrip: {
offline: "Hors ligne · synchro à la reconnexion",
offlineQueued_one: "Hors ligne · {{count}} modification en attente",
offlineQueued_many: "Hors ligne · {{count}} modifications en attente",
offlineQueued_other: "Hors ligne · {{count}} modifications en attente",
syncing_one: "Synchronisation de {{count}} modification…",
syncing_many: "Synchronisation de {{count}} modifications…",
syncing_other: "Synchronisation de {{count}} modifications…",
queued_one: "{{count}} modification en attente de synchro",
queued_many: "{{count}} modifications en attente de synchro",
queued_other: "{{count}} modifications en attente de synchro",
},
photoLimit: {
title: "Limite de photos atteinte",
body_one: "Vous pouvez joindre jusqu’à {{count}} photo ici. Supprimez-en une pour en ajouter une autre.",
body_many: "Vous pouvez joindre jusqu’à {{count}} de photos ici. Supprimez-en une pour en ajouter une autre.",
body_other: "Vous pouvez joindre jusqu’à {{count}} photos ici. Supprimez-en une pour en ajouter une autre.",
},
mapBoundary: {
start: "Touchez les coins de ce site",
more_one: "Touchez encore au moins {{count}} coin",
more_many: "Touchez encore au moins {{count}} de coins",
more_other: "Touchez encore au moins {{count}} coins",
adjust: "Faites glisser un coin pour ajuster, ou enregistrez",
},
importSites: {
listSeparator: ", ",
moreNames_one: ", +{{count}} autre",
moreNames_many: ", +{{count}} autres",
moreNames_other: ", +{{count}} autres",
confirmTitle_one: "Créer jusqu’à {{count}} nouveau site ?",
confirmTitle_many: "Créer jusqu’à {{count}} de nouveaux sites ?",
confirmTitle_other: "Créer jusqu’à {{count}} nouveaux sites ?",
confirmBody_one: "Cette importation créera jusqu’à {{count}} nouveau site et y liera des actifs :\n{{names}}{{more}}\n\nLes sites existants sont réutilisés lorsque le nom correspond. Revenez en arrière et corrigez d’abord la feuille si certains de ces noms sont des doublons ou des fautes de frappe.",
confirmBody_many: "Cette importation créera jusqu’à {{count}} de nouveaux sites et y liera des actifs :\n{{names}}{{more}}\n\nLes sites existants sont réutilisés lorsque le nom correspond. Revenez en arrière et corrigez d’abord la feuille si certains de ces noms sont des doublons ou des fautes de frappe.",
confirmBody_other: "Cette importation créera jusqu’à {{count}} nouveaux sites et y liera des actifs :\n{{names}}{{more}}\n\nLes sites existants sont réutilisés lorsque le nom correspond. Revenez en arrière et corrigez d’abord la feuille si certains de ces noms sont des doublons ou des fautes de frappe.",
backToPreview: "Retour à l’aperçu",
createAndImport: "Créer et importer",
actionCreate: "créer",
actionUpdate: "mettre à jour",
actionSkip: "ignorer",
actionError: "erreur",
calloutNew_one: "Jusqu’à {{count}} nouveau site sera créé",
calloutNew_many: "Jusqu’à {{count}} de nouveaux sites seront créés",
calloutNew_other: "Jusqu’à {{count}} nouveaux sites seront créés",
calloutMatched: "Sites associés par nom",
linkExisting_one: "Les actifs sont liés à {{count}} site existant associé par nom.",
linkExisting_many: "Les actifs sont liés à {{count}} de sites existants associés par nom.",
linkExisting_other: "Les actifs sont liés à {{count}} sites existants associés par nom.",
matchedCaseInsensitive: "Les noms sont associés aux sites existants (sans tenir compte des majuscules).",
reuseNote: " Les sites existants sont réutilisés lorsque le nom correspond — vous confirmez les nouveaux sites avant l’importation.",
},
attachmentsPanel: {
title: "Pièces jointes",
all: "Toutes",
empty: "Rien de joint pour le moment.",
kind: { photo: "Photos", video: "Vidéos", audio: "Voix", document: "Fichiers" },
source: {
fallback: "Pièce jointe",
"job.completion_photo": "Photo de fin de travaux",
"job.completion_video": "Vidéo de fin de travaux",
"job.completion_voice_note": "Note vocale de fin de travaux",
"job.receipt": "Reçu",
"job.activity_attachment": "Pièce jointe du fil d’activité",
"inspection.item_photo": "Photo d’inspection",
"inspection.item_video": "Vidéo d’inspection",
"inspection.item_voice_note": "Note vocale d’inspection",
},
},
};
